import api from "@/api_alv";
import Vue from "vue";
import { router } from "@/router.js";
import i18n from "@/assets/i18n/i18n";
import axios from "axios";

const DIR = "label/releases";
const DEFAULT_RELEASE = {
  id: 0,
  alvId: "ALV000000000LR",
  name: null,
  alternativeTitle: null,
  cover: false,
  performer: null,
  gemaReleaseType: null,
  mediaType: null,
  genre1: null,
  genre2: null,
  genre3: null,
  notes: null,
  ean: null,
  catalogueNumber: null,
  otherId: null,
  gemaCatalogueNumber: null,
  gemaRegistrationNumbers: null,
  gemaLtnNumber: null,
  cNotice: null,
  pNotice: null,
  labelId: null,
  minimumStock: null,
  numberOfDiscs: 1,
  volume: null,
  weight: null,
  hscode: null,
  countryOfOrigin: null,
  dateRetail: null,
  dateDigital: null,
  datePreRelease: null,
  conductor: null,
  musicians: null,
  priceCategory: null,
  selectedPricelist: null,
  language: null,
  tracks: null, // to be reactive maybe??
  tracksNumber: 0,
  compilationTracks: null,
  compilationLicenseeId: null,
  noGema: "yes",
  tags: null,
  favourites: "no",
  tracksOnRelease: [],
  artists: [],
  budget: [],
  costs: [],
  otherIds: [],
};

const DEFAULT_ARTISTS = {
  id: 0,
  artist: null,
  role: null,
  primary: "no",
  addToTracks: null,
};

const DEFAULT_PROMOTIONAL_TEXTS = {
  id: 0,
  description: null,
  type: null,
  language: null,
};

const DEFAULT_OTHER_IDS = {
  id: 0,
  sourceAlvId: null,
  otherId: null,
};

const DEFAULT_COSTS = {
  amount: null,
  billable: "no",
  costGroup: null,
  country: null,
  date: null,
  description: null,
  documentNumber: null,
  id: 0,
  paidOn: null,
  recipient: null,
};

const DEFAULT_BUDGET = {
  amount: null,
  budgetGroup: null,
  country: null,
  description: null,
  id: 0,
  quantity: null,
  scheduledMonth: null,
};

const DEFAULT_DIGITAL_DISTRIBUTION = {
  digitalRelease: null,
  id: 0,
  selected: "no",
  status: null,
};

const DEFAULT_COSTSPLITTING_DIALOG_DETAILS = {
  date: null,
  recipient: null,
  documentNumber: null,
  amount: null,
  costGroup: "manufacturing",
  country: null,
  // adding new row
  id: 0,
  release: null,
  description: null,
  share: null,
  proRataAmount: null,
};

const state = {
  // List
  labelReleases: [],
  selectedLabelReleases: [],
  isAllSelectedLabelReleases: false,
  expandedLabelReleases: [],
  labelReleasesServerSideSortingOptions: {
    sortBy: ["title"],
    sortDesc: [false],
    mustSort: true,
  },

  // Filters
  labelReleasesSearch: "",
  selectedLabelReleasesLabelsFilter: [],
  selectedLabelReleasesQualityFilter: [],
  selectedLabelReleasesDigitalDistributionStatus: [],
  selectedLabelReleasesYearFilter: [],
  selectedLabelReleasesCountryOfOriginFilter: [],

  // Actions
  selectedLabelReleasesAction: [],
  // Export
  showLabelReleasesExportDialog: false,
  labelReleasesExportAll: false,
  labelReleasesExportWithTracks: false,
  labelReleasesExportType: "excel",
  labelReleasesExportMappingId: null,
  // Release Delivery
  showReleaseDeliveryDialog: false,
  // releaseDeliveryDialogDetails: [],
  releaseDeliveryDialogDetails: {},
  // releaseDeliveryPolling: null,
  mainPercentageProgressbarReleaseDelivery: 0,
  // showCloseButton: false,
  xmlFilePath: null,
  xmlValidationErrorPath: null,
  releaseValidationInProgress: true,
  showMainProgressbar: false,
  // showLabelReleaseValidationErrorDialog: false,
  // releaseValidationErrorDetails: {},

  // Import (Mapping)
  releasesImportTags: "",
  releasesImportSelectedMapping: null,

  // Details (Edit Form + Read Only)
  defaultNewRelease: DEFAULT_RELEASE,
  releaseUniqueId: "",
  releaseDetails: DEFAULT_RELEASE,
  labelReleasesPricelistsOptions: [],
  labelReleaseLabelsDropdown: [],
  // Artist Connection
  labelReleasesDetailsConnectedArtist: null,
  artistForReleasesSearch: "",
  selectedArtistForReleases: [],
  totalListedConnectArtistToReleasesDialog: 0,
  totalRecordsConnectArtistToReleasesDialog: 0,
  labelReleasesDetailsSelectedAzTypeForArtist: null,
  labelReleasesArtistForReleasesConnectToAllTracksCheckbox: [],

  // TRACKS Panel
  labelReleaseTracks: [],
  labelReleaseTrackSearch: "",
  selectedTracksForRelease: [],
  totalTracksForReleaseListed: 0,
  totalTracksForReleaseRecords: 0,
  labelReleasesTracksSelectedDisc: 1,

  // DIGITAL DISTRIBUTION Panel
  releaseDigitalDistribution: [],
  selectedReleaseDigitalDistributionStatus: [],
  selectedReleaseDigitalDistribution: [],
  defaultReleaseDigitalDistribution: DEFAULT_DIGITAL_DISTRIBUTION,
  releaseDigitalDistributionEditingDetails: {
    // digitalPreRelease: null,
    digitalRelease: null,
  },
  releaseDigitalDistributionSetForAllCheckbox: false,
  showReleaseDigitalDistributionEditingDialog: false,

  // ARTISTS Panel
  releasesArtists: [],
  selectedReleasesArtists: [],
  showReleasesArtistsEditingDialog: false,
  defaultReleasesArtists: DEFAULT_ARTISTS,
  releasesArtistsEditingDialogDetails: DEFAULT_ARTISTS,
  releasesArtistsArtistOptions: [],

  // PROMOTIONAL TEXTS Panel
  releasesPromotionalTexts: [],
  selectedReleasesPromotionalTexts: [],
  showReleasesPromotionalTextsEditingDialog: false,
  defaultReleasesPromotionalTexts: DEFAULT_PROMOTIONAL_TEXTS,
  releasesPromotionalTextsEditingDialogDetails: DEFAULT_PROMOTIONAL_TEXTS,

  // OTHER IDS Panel
  releasesOtherIds: [],
  releasesOtherIdsSearch: "",
  selectedReleasesOtherIds: [],
  showReleasesOtherIdsEditingDialog: false,
  defaultReleasesOtherIds: DEFAULT_OTHER_IDS,
  releasesOtherIdsEditingDialogDetails: DEFAULT_OTHER_IDS,

  // COSTS Panel
  releasesCosts: [],
  selectedReleasesFilterCostGroup: null,
  selectedReleasesCosts: [],
  defaultReleasesCosts: DEFAULT_COSTS,
  showReleasesCostsEditingDialog: false,
  releasesCostsEditingDialogDetails: DEFAULT_COSTS,
  releasesCostsRecipientOptions: [],
  // Costsplitting
  showReleaseCostsplittingDialog: false,
  defaultReleaseCostsplittingDialogDetails: DEFAULT_COSTSPLITTING_DIALOG_DETAILS,
  releaseCostsplittingRows: [],
  releaseCostsplittingDialogDetails: DEFAULT_COSTSPLITTING_DIALOG_DETAILS,
  labelReleasesCostsplittingReleaseOptions: [],
  labelReleasesCostsplittingRecipientOptions: [],

  // BUDGET Panel
  releasesBudget: [],
  selectedReleasesFilterBudgetGroup: null,
  selectedReleasesBudget: [],
  defaultReleasesBudget: DEFAULT_BUDGET,
  showReleasesBudgetEditingDialog: false,
  releasesBudgetEditingDialogDetails: DEFAULT_BUDGET,

  // PROFIT & LOSS Panel (Read Only)
  releasesProfitAndLoss: {},
  releasesProfitAndLossResult: 0,
  selectedProfitAndLossFilterCostGroup: null,
  selectedProfitAndLossFilterIncomeGroup: null,
  profitAndLossFilterDetailsFromMonth: null,
  profitAndLossFilterDetailsToMonth: null,
  profitAndLossIsLoading: false,

  // Label Release test dialog
  labelTestReleasesDialog: false,
  testCalculationReleaseForm: {},
  labelReleaseTestCalculationResult: [],
  labelReleaseTestCalculationErrorMessage: null,
  testCalculationReleaseDetailsLicenses: null,
  testCalculationReleaseDetailsSalesType: null,
  testCalculationReleaseDetailsCountry: null,
  testCalculationReleaseDetailsNet: null,
  testCalculationReleaseDetailsQuantity: null,
  testCalculationReleaseDetailsPpd: null,
  testCalculationReleaseDetailsMsp: null,
  testCalculationReleaseDetailsIsrc: null,
};

const getters = {
  // List
  getLabelReleases(state) {
    return state.labelReleases;
  },
  getSelectedLabelReleases(state) {
    return state.selectedLabelReleases;
  },
  getIsAllSelectedLabelReleases(state) {
    return state.isAllSelectedLabelReleases;
  },
  getExpandedLabelReleases(state) {
    return state.expandedLabelReleases;
  },
  getLabelReleasesServerSideSortingOptions(state) {
    return state.labelReleasesServerSideSortingOptions;
  },

  // Filters
  getLabelReleasesSearch(state) {
    return state.labelReleasesSearch;
  },
  getSelectedLabelReleasesLabelsFilter(state) {
    return state.selectedLabelReleasesLabelsFilter;
  },
  getSelectedLabelReleasesQualityFilter(state) {
    return state.selectedLabelReleasesQualityFilter;
  },
  getSelectedLabelReleasesDigitalDistributionStatus(state) {
    return state.selectedLabelReleasesDigitalDistributionStatus;
  },
  getSelectedLabelReleasesYearFilter(state) {
    return state.selectedLabelReleasesYearFilter;
  },
  getSelectedLabelReleasesCountryOfOriginFilter(state) {
    return state.selectedLabelReleasesCountryOfOriginFilter;
  },

  // Actions
  getSelectedLabelReleasesAction(state) {
    return state.selectedLabelReleasesAction;
  },
  
  // Export
  getShowLabelReleasesExportDialog(state) {
    return state.showLabelReleasesExportDialog;
  },
  getLabelReleasesExportAll(state) {
    return state.labelReleasesExportAll;
  },
  getLabelReleasesExportWithTracks(state) {
    return state.labelReleasesExportWithTracks;
  },
  getLabelReleasesExportDetailsType(state) {
    return state.labelReleasesExportType;
  },
  getLabelReleasesExportDetailsMappingId(state) {
    return state.labelReleasesExportMappingId;
  },
  // Release Delivery
  getShowReleaseDeliveryDialog(state) {
    return state.showReleaseDeliveryDialog;
  },
  getReleaseDeliveryDialogDetails(state) {
    return state.releaseDeliveryDialogDetails;
  },
  // getReleaseDeliveryPolling(state)                 { return state.releaseDeliveryPolling },
  getMainPercentageProgressbarReleaseDelivery(state) {
    return state.mainPercentageProgressbarReleaseDelivery;
  },
  // getShowCloseButton(state)                        { return state.showCloseButton },
  getXmlFilePath(state) {
    return state.xmlFilePath;
  },
  getXmlValidationErrorPath(state) {
    return state.xmlValidationErrorPath;
  },
  getReleaseValidationInProgress(state) {
    return state.releaseValidationInProgress;
  },
  getShowMainProgressbar(state) {
    return state.showMainProgressbar;
  },
  // getShowLabelReleaseValidationErrorDialog(state)  { return state.showLabelReleaseValidationErrorDialog },
  // getReleaseValidationErrorDetails(state)          { return state.releaseValidationErrorDetails },

  // Import (Mapping)
  getLabelReleasesDetailsImportTags(state) {
    return state.releasesImportTags;
  },
  getLabelReleasesDetailsImportSelectedMapping(state) {
    return state.releasesImportSelectedMapping
  },

  // Details
  getDefaultNewLabelRelease(state) {
    return state.defaultNewRelease;
  },
  getLabelReleasesUniqueId(state) {
    return state.releaseUniqueId;
  },
  getLabelReleasesDetails(state) {
    return state.releaseDetails;
  },
  getLabelReleasesPricelistsOptions(state) {
    return state.labelReleasesPricelistsOptions;
  },
  getLabelReleaseLabelsDropdown(state) {
    return state.labelReleaseLabelsDropdown;
  },
  // Artist Connection
  getLabelReleasesDetailsConnectedArtist(state) {
    return state.labelReleasesDetailsConnectedArtist;
  },
  getArtistForReleasesSearch(state) {
    return state.artistForReleasesSearch;
  },
  getSelectedArtistForReleases(state) {
    return state.selectedArtistForReleases;
  },
  getTotalListedConnectArtistToReleasesDialog(state) {
    return state.totalListedConnectArtistToReleasesDialog;
  },
  getTotalRecordsConnectArtistToReleasesDialog(state) {
    return state.totalRecordsConnectArtistToReleasesDialog;
  },
  getLabelReleasesDetailsSelectedAzTypeForArtist(state) {
    return state.labelReleasesDetailsSelectedAzTypeForArtist;
  },
  //
  getLabelReleasesArtistForReleasesConnectToAllTracksCheckbox(state) {
    return state.labelReleasesArtistForReleasesConnectToAllTracksCheckbox;
  },
  // Edit Form Fields
  getLabelReleasesDetailsAlvId(state) {
    return state.releaseDetails.alvId;
  },
  getLabelReleasesDetailsReleaseTitle(state) {
    return state.releaseDetails.name;
  },
  getLabelReleasesDetailsAlternativeTitle(state) {
    return state.releaseDetails.alternativeTitle;
  },
  getLabelReleasesDetailsArtist(state) {
    return state.releaseDetails.performer;
  },
  getLabelReleasesDetailsSelectedGemaTypeId(state) {
    return state.releaseDetails.gemaReleaseType;
  },
  getLabelReleasesDetailsSelectedMediaTypeId(state) {
    return state.releaseDetails.mediaType;
  },
  getLabelReleasesDetailsSelectedGenre1Id(state) {
    return state.releaseDetails.genre1;
  },
  getLabelReleasesDetailsSelectedGenre2Id(state) {
    return state.releaseDetails.genre2;
  },
  getLabelReleasesDetailsSelectedGenre3Id(state) {
    return state.releaseDetails.genre3;
  },
  getLabelReleasesDetailsNotes(state) {
    return state.releaseDetails.notes;
  },
  getLabelReleasesDetailsEanUpc(state) {
    return state.releaseDetails.ean;
  },
  getLabelReleasesDetailsCatalogueNumber(state) {
    return state.releaseDetails.catalogueNumber;
  },
  getLabelReleasesDetailsOtherId(state) {
    return state.releaseDetails.otherId;
  },
  getLabelReleasesDetailsGemaCatalogueNumber(state) {
    return state.releaseDetails.gemaCatalogueNumber;
  },
  getLabelReleasesDetailsGemaRegistrationNumber(state) {
    return state.releaseDetails.gemaRegistrationNumbers;
  },
  getLabelReleasesDetailsGemaLtnNumber(state) {
    return state.releaseDetails.gemaLtnNumber;
  },
  getLabelReleasesDetailsCNotice(state) {
    return state.releaseDetails.cNotice;
  },
  getLabelReleasesDetailsPNotice(state) {
    return state.releaseDetails.pNotice;
  },
  getLabelReleasesDetailsSelectedLabelId(state) {
    return state.releaseDetails.labelId;
  },
  getLabelReleasesDetailsMinimumStock(state) {
    return state.releaseDetails.minimumStock;
  },
  getLabelReleasesDetailsSelectedNumberOfDiscs(state) {
    return state.releaseDetails.numberOfDiscs;
  },
  getLabelReleasesDetailsVolume(state) { 
    return state.releaseDetails.volume 
  },
  getLabelReleasesDetailsWeight(state) { 
    return state.releaseDetails.weight 
  },
  getLabelReleasesDetailsHsCode(state){
    return state.releaseDetails.hscode
  },
  getLabelReleasesDetailsCountryOfOrigin(state) {
    return state.releaseDetails.countryOfOrigin
  },
  getLabelReleasesDetailsDatePhysical(state) {
    return state.releaseDetails.dateRetail;
  },
  getLabelReleasesDetailsDateDigital(state) {
    return state.releaseDetails.dateDigital;
  },
  getLabelReleasesDetailsDatePrerelease(state) {
    return state.releaseDetails.datePreRelease;
  },
  getLabelReleasesDetailsConductor(state) {
    return state.releaseDetails.conductor;
  },
  getLabelReleasesDetailsMusicians(state) {
    return state.releaseDetails.musicians;
  },
  getLabelReleasesDetailsSelectedCategoryId(state) {
    return state.releaseDetails.priceCategory;
  },
  getLabelReleasesDetailsSelectedLanguageId(state) {
    return state.releaseDetails.language;
  },
  getLabelReleasesDetailsTracksNumber(state) {
    return state.releaseDetails.tracks;
  },
  getLabelReleasesDetailsCompilationTracks(state) {
    return state.releaseDetails.compilationTracks;
  },
  getLabelReleasesDetailsSelectedLicensorId(state) {
    return state.releaseDetails.compilationLicenseeId;
  },
  getLabelReleasesDetailsSelectedGemaTasId(state) {
    return state.releaseDetails.noGema;
  },
  getLabelReleasesDetailsTags(state) {
    return state.releaseDetails.tags;
  },
  getLabelReleasesDetailsFavourite(state) {
    return state.releaseDetails.favourites;
  },
  getLabelReleasesDetailsSelectedReleasePricelists(state) {
    return state.releaseDetails.selectedPricelist;
  },

  // PROFIT & LOSS Panel (Read only)
  getReleasesProfitAndLoss(state) {
    return state.releasesProfitAndLoss;
  },
  getReleasesProfitAndLossResult(state) {
    return state.releasesProfitAndLossResult;
  },
  getSelectedProfitAndLossFilterCostGroup(state) {
    return state.selectedProfitAndLossFilterCostGroup;
  },
  getSelectedProfitAndLossFilterIncomeGroup(state) {
    return state.selectedProfitAndLossFilterIncomeGroup;
  },
  getProfitAndLossFilterDetailsFromMonth(state) {
    return state.profitAndLossFilterDetailsFromMonth;
  },
  getProfitAndLossFilterDetailsToMonth(state) {
    return state.profitAndLossFilterDetailsToMonth;
  },
  getProfitAndLossIsLoading(state) {
    return state.profitAndLossIsLoading;
  },

  // TRACKS Panel
  getLabelReleaseTracks(state) {
    return state.labelReleaseTracks;
  },
  getLabelReleaseTrackSearch(state) {
    return state.labelReleaseTrackSearch;
  },
  getSelectedLabelReleaseTrack(state) {
    return state.selectedTracksForRelease;
  },
  getTotalLabelReleaseTrackListed(state) {
    return state.totalTracksForReleaseListed;
  },
  getTotalLabelReleaseTrackRecords(state) {
    return state.totalTracksForReleaseRecords;
  },
  getLabelReleasesTracksSelectedDisc(state) {
    return state.labelReleasesTracksSelectedDisc;
  },

  // DIGITAL DISTRIBUTION Panel
  getReleaseDigitalDistribution(state) {
    return state.releaseDigitalDistribution;
  },
  // Editing
  getSelectedReleaseDigitalDistributionStatus(state) {
    return state.selectedReleaseDigitalDistributionStatus;
  },
  getSelectedReleaseDigitalDistribution(state) {
    return state.selectedReleaseDigitalDistribution;
  },
  getDefaultReleaseDigitalDistribution(state) {
    return state.defaultReleaseDigitalDistribution;
  },
  getReleaseDigitalDistributionEditingDialogDetails(state) {
    return state.releaseDigitalDistributionEditingDetails;
  },
  getReleaseDigitalDistributionDetailsDigitalRelease(state) {
    return state.releaseDigitalDistributionEditingDetails.digitalRelease;
  },
  getReleaseDigitalDistributionDetailsSelected(state) {
    return state.releaseDigitalDistributionEditingDetails.selected;
  },
  getReleaseDigitalDistributionDetailsStatus(state) {
    return state.releaseDigitalDistributionEditingDetails.status;
  },
  getReleaseDigitalDistributionSetForAllCheckbox(state) {
    return state.releaseDigitalDistributionSetForAllCheckbox;
  },
  getShowReleaseDigitalDistributionEditingDialog(state) {
    return state.showReleaseDigitalDistributionEditingDialog;
  },
  // getReleaseDigitalDistributionDetailsDigitalPreRelease(state) { return state.releaseDigitalDistributionEditingDetails.digitalPreRelease },

  // ARTISTS Panel
  getReleasesArtists(state) {
    return state.releasesArtists;
  },
  // Editing
  getSelectedReleasesArtists(state) {
    return state.selectedReleasesArtists;
  },
  getShowReleasesArtistsEditingDialog(state) {
    return state.showReleasesArtistsEditingDialog;
  },
  getDefaultReleasesArtists(state) {
    return state.defaultReleasesArtists;
  },
  getReleasesArtistsEditingDialogDetails(state) {
    return state.releasesArtistsEditingDialogDetails;
  },
  getReleasesArtistsDetailsArtist(state) {
    return state.releasesArtistsEditingDialogDetails.artist;
  },
  getReleasesArtistsDetailsRole(state) {
    return state.releasesArtistsEditingDialogDetails.role;
  },
  getReleasesArtistsDetailsPrimary(state) {
    return state.releasesArtistsEditingDialogDetails.primary;
  },
  getReleasesArtistsArtistOptions(state) {
    return state.releasesArtistsArtistOptions;
  },
  getLabelReleasesArtistsPanelConnectToAllTracksCheckbox(state) {
    return state.releasesArtistsEditingDialogDetails.addToTracks;
  },

  // PROMOTIONAL TEXTS Panel
  getReleasesPromotionalTexts(state) {
    return state.releasesPromotionalTexts;
  },
  // Editing
  getSelectedReleasesPromotionalTexts(state) {
    return state.selectedReleasesPromotionalTexts;
  },
  getShowReleasesPromotionalTextsEditingDialog(state) {
    return state.showReleasesPromotionalTextsEditingDialog;
  },
  getDefaultReleasesPromotionalTexts(state) {
    return state.defaultReleasesPromotionalTexts;
  },
  getReleasesPromotionalTextsEditingDialogDetails(state) {
    return state.releasesPromotionalTextsEditingDialogDetails;
  },
  getReleasesPromotionalTextsDetailsDescription(state) {
    return state.releasesPromotionalTextsEditingDialogDetails.description;
  },
  getReleasesPromotionalTextsDetailsType(state) {
    return state.releasesPromotionalTextsEditingDialogDetails.type;
  },
  getReleasesPromotionalTextsDetailsLanguage(state) {
    return state.releasesPromotionalTextsEditingDialogDetails.language;
  },

  // OTHER IDS Panel
  getReleasesOtherIds(state) {
    return state.releasesOtherIds;
  },
  getReleasesOtherIdsSearch(state) {
    return state.releasesOtherIdsSearch;
  },
  // Editing
  getSelectedReleasesOtherIds(state) {
    return state.selectedReleasesOtherIds;
  },
  getShowReleasesOtherIdsEditingDialog(state) {
    return state.showReleasesOtherIdsEditingDialog;
  },
  getDefaultReleasesOtherIds(state) {
    return state.defaultReleasesOtherIds;
  },
  getReleasesOtherIdsEditingDialogDetails(state) {
    return state.releasesOtherIdsEditingDialogDetails;
  },
  getReleasesOtherIdsDetailsSourceAlvId(state) {
    return state.releasesOtherIdsEditingDialogDetails.sourceAlvId;
  },
  getReleasesOtherIdsDetailsOtherId(state) {
    return state.releasesOtherIdsEditingDialogDetails.otherId;
  },

  // COSTS Panel
  getReleasesCosts(state) {
    return state.releasesCosts;
  },
  getSelectedReleasesFilterCostGroup(state) {
    return state.selectedReleasesFilterCostGroup;
  },
  // Editing
  getSelectedReleasesCosts(state) {
    return state.selectedReleasesCosts;
  },
  getDefaultReleasesCosts(state) {
    return state.defaultReleasesCosts;
  },
  getShowReleasesCostsEditingDialog(state) {
    return state.showReleasesCostsEditingDialog;
  },
  getReleasesCostsEditingDialogDetails(state) {
    return state.releasesCostsEditingDialogDetails;
  },
  getReleasesCostsDetailsAmount(state) {
    return state.releasesCostsEditingDialogDetails.amount;
  },
  // getReleasesCostsDetailsBillable(state)       { return state.releasesCostsEditingDialogDetails.billable },
  getReleasesCostsDetailsCostGroup(state) {
    return state.releasesCostsEditingDialogDetails.costGroup;
  },
  getReleasesCostsDetailsCountry(state) {
    return state.releasesCostsEditingDialogDetails.country;
  },
  getReleasesCostsDetailsDate(state) {
    return state.releasesCostsEditingDialogDetails.date;
  },
  getReleasesCostsDetailsDescription(state) {
    return state.releasesCostsEditingDialogDetails.description;
  },
  getReleasesCostsDetailsDocumentNumber(state) {
    return state.releasesCostsEditingDialogDetails.documentNumber;
  },
  getReleasesCostsDetailsPaidOn(state) {
    return state.releasesCostsEditingDialogDetails.paidOn;
  },
  getReleasesCostsDetailsRecipient(state) {
    return state.releasesCostsEditingDialogDetails.recipient;
  },
  getReleasesCostsRecipientOptions(state) {
    return state.releasesCostsRecipientOptions;
  },
  // Costsplitting Function
  getShowReleaseCostsplittingDialog(state) {
    return state.showReleaseCostsplittingDialog;
  },
  getDefaultReleaseCostsplittingDialogDetails(state) {
    return state.defaultReleaseCostsplittingDialogDetails;
  },
  getReleaseCostsplittingDialogDetails(state) {
    return state.releaseCostsplittingDialogDetails;
  },
  getLabelReleasesCostsplittingDetailsDate(state) {
    return state.releaseCostsplittingDialogDetails.date;
  },
  getLabelReleasesCostsplittingDetailsRecipient(state) {
    return state.releaseCostsplittingDialogDetails.recipient;
  },
  getLabelReleasesCostsplittingRecipientOptions(state) {
    return state.labelReleasesCostsplittingRecipientOptions;
  },
  getLabelReleasesCostsplittingDetailsDocumentNumber(state) {
    return state.releaseCostsplittingDialogDetails.documentNumber;
  },
  getLabelReleasesCostsplittingDetailsAmount(state) {
    return state.releaseCostsplittingDialogDetails.amount;
  },
  getLabelReleasesCostsplittingDetailsCostGroup(state) {
    return state.releaseCostsplittingDialogDetails.costGroup;
  },
  getLabelReleasesCostsplittingDetailsCountry(state) {
    return state.releaseCostsplittingDialogDetails.country;
  },
  // Costsplitting Dialog Rows
  getReleaseCostsplittingRows(state) {
    return state.releaseCostsplittingRows;
  },
  getLabelReleasesCostsplittingDetailsDescription(state) {
    return state.releaseCostsplittingDialogDetails.description;
  },
  getLabelReleasesCostsplittingDetailsRelease(state) {
    return state.releaseCostsplittingDialogDetails.release;
  },
  getLabelReleasesCostsplittingDetailsShare(state) {
    return state.releaseCostsplittingDialogDetails.share;
  },
  getLabelReleasesCostsplittingReleaseOptions(state) {
    return state.labelReleasesCostsplittingReleaseOptions;
  },

  // BUDGET Panel
  getReleasesBudget(state) {
    return state.releasesBudget;
  },
  getSelectedReleasesFilterBudgetGroup(state) {
    return state.selectedReleasesFilterBudgetGroup;
  },
  // Editing
  getSelectedReleasesBudget(state) {
    return state.selectedReleasesBudget;
  },
  getDefaultReleasesBudget(state) {
    return state.defaultReleasesBudget;
  },
  getShowReleasesBudgetEditingDialog(state) {
    return state.showReleasesBudgetEditingDialog;
  },
  getReleasesBudgetEditingDialogDetails(state) {
    return state.releasesBudgetEditingDialogDetails;
  },
  getReleasesBudgetDetailsBudgetGroup(state) {
    return state.releasesBudgetEditingDialogDetails.budgetGroup;
  },
  getReleasesBudgetDetailsScheduledMonth(state) {
    return state.releasesBudgetEditingDialogDetails.scheduledMonth;
  },
  getReleasesBudgetDetailsDescription(state) {
    return state.releasesBudgetEditingDialogDetails.description;
  },
  getReleasesBudgetDetailsAmount(state) {
    return state.releasesBudgetEditingDialogDetails.amount;
  },
  getReleasesBudgetDetailsCountry(state) {
    return state.releasesBudgetEditingDialogDetails.country;
  },
  getReleasesBudgetDetailsQuantity(state) {
    return state.releasesBudgetEditingDialogDetails.quantity;
  },

  // Label Release test dialog
  getLabelReleaseTestCalculationResult: (state) => {
    return state.labelReleaseTestCalculationResult;
  },
  getLabelReleaseTestCalculationErrorMessage: (state) => {
    return state.labelReleaseTestCalculationErrorMessage;
  },
  getTestCalculationReleaseForm(state) {
    return state.testCalculationReleaseForm;
  },
  getLabelTestReleasesDialog(state) {
    return state.labelTestReleasesDialog;
  },
  getTestCalculationReleaseDetailsLicenses(state) {
    return state.testCalculationReleaseDetailsLicenses;
  },
  getTestCalculationReleaseDetailsSalesType(state) {
    return state.testCalculationReleaseDetailsSalesType;
  },
  getTestCalculationReleaseDetailsCountry(state) {
    return state.testCalculationReleaseDetailsCountry;
  },
  getTestCalculationReleaseDetailsNet(state) {
    return state.testCalculationReleaseDetailsNet;
  },
  getTestCalculationReleaseDetailsQuantity(state) {
    return state.testCalculationReleaseDetailsQuantity;
  },
  getTestCalculationReleaseDetailsPpd(state) {
    return state.testCalculationReleaseDetailsPpd;
  },
  getTestCalculationReleaseDetailsIsrc(state) {
    return state.testCalculationReleaseDetailsIsrc;
  },
  getTestCalculationReleaseDetailsMsp(state) {
    return state.testCalculationReleaseDetailsMsp;
  },

  //Image Uploader
  getLabelReleasesImageUrl(state) {
    return state.selectedLabelReleases.cover;
  },
};

const mutations = {
  // List
  setLabelReleases: (state, releases) => {
    state.labelReleases = releases;
  },
  setSelectedLabelReleases: (state, selectedReleases) => {
    state.selectedLabelReleases = selectedReleases;
  },
  setIsAllSelectedLabelReleases: (state, isSelected) => {
    state.isAllSelectedLabelReleases = isSelected;
  },
  setExpandedLabelReleases: (state, release) => {
    state.expandedLabelReleases = [release];
    // if(Object.keys(release).length === 0) state.expandedLabelReleases = []
    // else state.expandedLabelReleases.push(release)
  },
  setLabelReleasesServerSideSortingOptions: (state, value) => {
    state.labelReleasesServerSideSortingOptions = value;
  },

  // Filters
  setLabelReleasesSearch: (state, value) => {
    state.labelReleasesSearch = value;
  },
  setSelectedLabelReleasesLabelsFilter: (state, value) => {
    state.selectedLabelReleasesLabelsFilter = value;
  },
  setSelectedLabelReleasesQualityFilter: (state, value) => {
    state.selectedLabelReleasesQualityFilter = value;
  },
  setSelectedLabelReleasesDigitalDistributionStatus: (state, value) => {
    state.selectedLabelReleasesDigitalDistributionStatus = value;
  },
  setSelectedLabelReleasesYearsFilter: (state, value) => {
    state.selectedLabelReleasesYearFilter = value;
  },
  setSelectedLabelReleasesCountryOfOriginFilter: (state, value) => {
    state.selectedLabelReleasesCountryOfOriginFilter = value;
  },

  // Actions
  setSelectedLabelReleasesAction: (state, action) => {
    state.selectedLabelReleasesAction = action;
  },

  // Label Release test dialog
  setLabelTestReleasesDialog: (state, value) => {
    state.labelTestReleasesDialog = value;
  },
  setLabelReleaseTestCalculationErrorMessage: (state, value) => {
    state.labelReleaseTestCalculationErrorMessage = value;
  },
  setLabelReleaseTestCalculationResult: (state, value) => {
    state.labelReleaseTestCalculationResult = value;
  },
  setTestCalculationReleaseForm(state, value) {
    state.testCalculationReleaseForm = value;
  },
  setTestCalculationReleaseDetailsLicenses(state, value) {
    state.testCalculationReleaseDetailsLicenses = value;
  },
  setTestCalculationReleaseDetailsSalesType(state, value) {
    state.testCalculationReleaseDetailsSalesType = value;
  },
  setTestCalculationReleaseDetailsCountry(state, value) {
    state.testCalculationReleaseDetailsCountry = value;
  },
  setTestCalculationReleaseDetailsNet(state, value) {
    state.testCalculationReleaseDetailsNet = value;
  },
  setTestCalculationReleaseDetailsQuantity(state, value) {
    state.testCalculationReleaseDetailsQuantity = value;
  },
  setTestCalculationReleaseDetailsPpd(state, value) {
    state.testCalculationReleaseDetailsPpd = value;
  },
  setTestCalculationReleaseDetailsIsrc(state, value) {
    state.testCalculationReleaseDetailsIsrc = value;
  },
  setTestCalculationReleaseDetailsMsp(state, value) {
    state.testCalculationReleaseDetailsMsp = value;
  },

  // Export
  setShowLabelReleasesExportDialog: (state, show) => {
    state.showLabelReleasesExportDialog = show;
  },
  setLabelReleasesExportAll: (state, value) => {
    state.labelReleasesExportAll = value;
  },
  setLabelReleasesExportWithTracks: (state, value) => {
    state.labelReleasesExportWithTracks = value;
  },
  setLabelReleasesExportDetailsType: (state, value) => {
    state.labelReleasesExportType = value;
  },
  setLabelReleasesExportDetailsMappingId: (state, value) => {
    state.labelReleasesExportMappingId = value;
  },
  // Release Delivery
  setShowReleaseDeliveryDialog: (state, show) => {
    state.showReleaseDeliveryDialog = show;
  },
  setReleaseDeliveryDialogDetails: (state, details) => {
    state.releaseDeliveryDialogDetails = details;
  },
  // setReleaseDeliveryDialogDetails: (state, details) => {
  //     if(details.length === 0) state.releaseDeliveryDialogDetails = []
  //     else state.releaseDeliveryDialogDetails.push(details)
  // },
  // setReleaseDeliveryPolling: (state, polling) => { state.releaseDeliveryPolling = polling },
  setMainPercentageProgressbarReleaseDelivery: (state, value) => {
    state.mainPercentageProgressbarReleaseDelivery = value;
  },
  // setShowCloseButton: (state, show) => { state.showCloseButton = show },
  setXmlFilePath: (state, path) => {
    state.xmlFilePath = path;
  },
  setXmlValidationErrorPath: (state, path) => {
    state.xmlValidationErrorPath = path;
  },
  setReleaseValidationInProgress: (state, inProgress) => {
    state.releaseValidationInProgress = inProgress;
  },
  setShowMainProgressbar: (state, show) => {
    state.showMainProgressbar = show;
  },
  // setShowLabelReleaseValidationErrorDialog: (state, show) => { state.showLabelReleaseValidationErrorDialog = show },
  // setReleaseValidationErrorDetails: (state, details) => { state.releaseValidationErrorDetails = details },

  // Import (Mapping)
  setLabelReleasesDetailsImportTags: (state, value) => {
    state.releasesImportTags = value;
  },
  setLabelReleasesDetailsImportSelectedMapping: (state, value) => {
    state.releasesImportSelectedMapping = value;
  },

  // Details
  setDefaultNewLabelRelease: (state) => {
    state.defaultNewRelease = DEFAULT_RELEASE;
  },
  setLabelReleasesUniqueId: (state, uniqueId) => {
    state.releaseUniqueId = uniqueId;
  },
  setLabelReleasesDetails: (state, details) => {
    state.releaseDetails = details;
  },
  setLabelReleasesPricelistsOptions: (state, options) => {
    state.labelReleasesPricelistsOptions = options;
  },
  setLabelReleaseLabelsDropdown: (state, value) => {
    state.labelReleaseLabelsDropdown = value;
  },
  // Artist Connection
  setLabelReleasesDetailsConnectedArtist: (state, artist) => {
    state.labelReleasesDetailsConnectedArtist = artist;
  },
  setArtistForReleasesSearch: (state, search) => {
    state.artistForReleasesSearch = search;
  },
  setSelectedArtistForReleases: (state, selected) => {
    state.selectedArtistForReleases = selected;
  },
  setTotalListedConnectArtistToReleasesDialog: (state, number) => {
    state.totalListedConnectArtistToReleasesDialog = number;
  },
  setTotalRecordsConnectArtistToReleasesDialog: (state, number) => {
    state.totalRecordsConnectArtistToReleasesDialog = number;
  },
  setLabelReleasesDetailsSelectedAzTypeForArtist: (state, selected) => {
    state.labelReleasesDetailsSelectedAzTypeForArtist = selected;
  },
  //
  setLabelReleasesArtistForReleasesConnectToAllTracksCheckbox: (
    state,
    option
  ) => {
    state.labelReleasesArtistForReleasesConnectToAllTracksCheckbox = option;
  },

  // Edit Form Fields
  setLabelReleasesDetailsAlvId: (state, alvId) => {
    state.releaseDetails.alvId = alvId;
  },
  setLabelReleasesDetailsReleaseTitle: (state, title) => {
    state.releaseDetails.name = title;
  },
  setLabelReleasesDetailsAlternativeTitle: (state, title) => {
    state.releaseDetails.alternativeTitle = title;
  },
  setLabelReleasesDetailsArtist: (state, value) => {
    state.releaseDetails.performer = value;
  },
  setLabelReleasesDetailsSelectedGemaTypeId: (state, value) => {
    state.releaseDetails.gemaReleaseType = value;
  },
  setLabelReleasesDetailsSelectedMediaTypeId: (state, value) => {
    state.releaseDetails.mediaType = value;
  },
  setLabelReleasesDetailsSelectedGenre1Id: (state, value) => {
    state.releaseDetails.genre1 = value;
  },
  setLabelReleasesDetailsSelectedGenre2Id: (state, value) => {
    state.releaseDetails.genre2 = value;
  },
  setLabelReleasesDetailsSelectedGenre3Id: (state, value) => {
    state.releaseDetails.genre3 = value;
  },
  setLabelReleasesDetailsNotes: (state, value) => {
    state.releaseDetails.notes = value;
  },
  setLabelReleasesDetailsEanUpc: (state, value) => {
    state.releaseDetails.ean = value;
  },
  setLabelReleasesDetailsCatalogueNumber: (state, value) => {
    state.releaseDetails.catalogueNumber = value;
  },
  setLabelReleasesDetailsOtherId: (state, value) => {
    state.releaseDetails.otherId = value;
  },
  setLabelReleasesDetailsGemaCatalogueNumber: (state, value) => {
    state.releaseDetails.gemaCatalogueNumber = value;
  },
  setLabelReleasesDetailsGemaRegistrationNumber: (state, value) => {
    state.releaseDetails.gemaRegistrationNumbers = value;
  },
  setLabelReleasesDetailsGemaLtnNumber: (state, value) => {
    state.releaseDetails.gemaLtnNumber = value;
  },
  setLabelReleasesDetailsCNotice: (state, value) => {
    state.releaseDetails.cNotice = value;
  },
  setLabelReleasesDetailsPNotice: (state, value) => {
    state.releaseDetails.pNotice = value;
  },
  setLabelReleasesDetailsSelectedLabelId: (state, id) => {
    state.releaseDetails.labelId = id;
  },
  setLabelReleasesDetailsMinimumStock: (state, value) => {
    state.releaseDetails.minimumStock = value;
  },
  setLabelReleasesDetailsSelectedNumberOfDiscs: (state, value) => {
    state.releaseDetails.numberOfDiscs = value;
  },
  setLabelReleasesDetailsVolume: (state, value) => { 
    state.releaseDetails.volume = value 
  },
  setLabelReleasesDetailsWeight: (state, value) => { 
    state.releaseDetails.weight = value 
  },
  setLabelReleasesDetailsHsCode: (state, value) => { 
    state.releaseDetails.hscode = value 
  },
  setLabelReleasesDetailsCountryOfOrigin: (state, value) => {
    state.releaseDetails.countryOfOrigin = value
  },
  setLabelReleasesDetailsDatePhysical: (state, value) => {
    state.releaseDetails.dateRetail = value;
  },
  setLabelReleasesDetailsDateDigital: (state, value) => {
    state.releaseDetails.dateDigital = value;
  },
  setLabelReleasesDetailsDatePrerelease: (state, value) => {
    state.releaseDetails.datePreRelease = value;
  },
  setLabelReleasesDetailsConductor: (state, value) => {
    state.releaseDetails.conductor = value;
  },
  setLabelReleasesDetailsMusicians: (state, value) => {
    state.releaseDetails.musicians = value;
  },
  setLabelReleasesDetailsSelectedCategoryId: (state, value) => {
    state.releaseDetails.priceCategory = value;
  },
  setLabelReleasesDetailsSelectedLanguageId: (state, value) => {
    state.releaseDetails.language = value;
  },
  setLabelReleasesDetailsTracksNumber: (state, tracks) => {
    state.releaseDetails.tracks = tracks;
  },
  setLabelReleasesDetailsCompilationTracks: (state, value) => {
    state.releaseDetails.compilationTracks = value;
  },
  setLabelReleasesDetailsSelectedLicensorId: (state, value) => {
    state.releaseDetails.compilationLicenseeId = value;
  },
  setLabelReleasesDetailsSelectedGemaTasId: (state, value) => {
    state.releaseDetails.noGema = value;
  },
  setLabelReleasesDetailsTags: (state, value) => {
    state.releaseDetails.tags = value;
  },
  setLabelReleasesDetailsFavourite: (state, value) => {
    state.releaseDetails.favourites = value;
  },
  setLabelReleasesDetailsSelectedReleasePricelists: (state, value) => {
    state.releaseDetails.selectedPricelist = value;
  },

  // TRACKS Panel
  setLabelReleaseTracks: (state, tracks) => {
    state.labelReleaseTracks = tracks;
  },
  setSpecificLabelReleaseTracks: (state, tracks) => {
    Vue.set(
      state.labelReleaseTracks,
      state.labelReleasesTracksSelectedDisc,
      tracks
    );
  },
  setLabelReleaseTrackSearch: (state, search) => {
    state.labelReleaseTrackSearch = search;
  },
  setSelectedLabelReleaseTrack: (state, track) => {
    state.selectedTracksForRelease = track;
  },
  setTotalLabelReleaseTrackListed: (state, track) => {
    state.totalTracksForReleaseListed = track;
  },
  setTotalLabelReleaseTrackRecords: (state, track) => {
    state.totalTracksForReleaseRecords = track;
  },
  setLabelReleasesTracksSelectedDisc: (state, selected) => {
    state.labelReleasesTracksSelectedDisc = selected;
  },

  // Digital Distribution Panel
  setReleaseDigitalDistribution: (state, rows) => {
    state.releaseDigitalDistribution = rows;
  },
  // Editing
  setSelectedReleaseDigitalDistributionStatus: (state, selected) => {
    state.selectedReleaseDigitalDistributionStatus = selected;
  },
  setSelectedReleaseDigitalDistribution: (state, selected) => {
    state.selectedReleaseDigitalDistribution = selected;
  },
  setDefaultReleaseDigitalDistribution: (state) => {
    state.defaultReleaseDigitalDistribution = DEFAULT_DIGITAL_DISTRIBUTION;
  },
  setReleaseDigitalDistributionEditingDialogDetails: (state, details) => {
    state.releaseDigitalDistributionEditingDetails = details;
  },
  setReleaseDigitalDistributionDetailsDigitalRelease: (state, date) => {
    state.releaseDigitalDistributionEditingDetails.digitalRelease = date;
  },
  // setReleaseDigitalDistributionDetailsDigitalPreRelease:   (state, date)     => { state.releaseDigitalDistributionEditingDetails.digitalPreRelease = date },
  setReleaseDigitalDistributionDetailsSelected: (state, selected) => {
    state.releaseDigitalDistributionEditingDetails.selected = selected;
  },
  setReleaseDigitalDistributionDetailsStatus: (state, status) => {
    state.releaseDigitalDistributionEditingDetails.status = status;
  },
  setReleaseDigitalDistributionSetForAllCheckbox: (state, checkbox) => {
    state.releaseDigitalDistributionSetForAllCheckbox = checkbox;
  },
  setShowReleaseDigitalDistributionEditingDialog: (state, show) => {
    state.showReleaseDigitalDistributionEditingDialog = show;
  },

  // ARTISTS Panel
  setReleasesArtists: (state, artists) => {
    state.releasesArtists = artists;
  },
  // Editing
  setSelectedReleasesArtists: (state, artist) => {
    state.selectedReleasesArtists = artist;
  },
  setShowReleasesArtistsEditingDialog: (state, show) => {
    state.showReleasesArtistsEditingDialog = show;
  },
  setDefaultReleasesArtists: (state) => {
    state.defaultReleasesArtists = DEFAULT_ARTISTS;
  },
  setReleasesArtistsEditingDialogDetails: (state, details) => {
    state.releasesArtistsEditingDialogDetails = details;
  },
  setReleasesArtistsDetailsArtist: (state, artist) => {
    state.releasesArtistsEditingDialogDetails.artist = artist;
  },
  setReleasesArtistsDetailsRole: (state, role) => {
    state.releasesArtistsEditingDialogDetails.role = role;
  },
  setReleasesArtistsDetailsPrimary: (state, check) => {
    state.releasesArtistsEditingDialogDetails.primary = check;
  },
  setReleasesArtistsArtistOptions: (state, options) => {
    state.releasesArtistsArtistOptions = options;
  },
  setLabelReleasesArtistsPanelConnectToAllTracksCheckbox: (state, option) => {
    state.releasesArtistsEditingDialogDetails.addToTracks = option;
  },

  // PROMOTIONAL TEXTS Panel
  setReleasesPromotionalTexts: (state, texts) => {
    state.releasesPromotionalTexts = texts;
  },
  // Editing
  setSelectedReleasesPromotionalTexts: (state, selected) => {
    state.selectedReleasesPromotionalTexts = selected;
  },
  setShowReleasesPromotionalTextsEditingDialog: (state, show) => {
    state.showReleasesPromotionalTextsEditingDialog = show;
  },
  setDefaultReleasesPromotionalTexts: (state) => {
    state.defaultReleasesPromotionalTexts = DEFAULT_PROMOTIONAL_TEXTS;
  },
  setReleasesPromotionalTextsEditingDialogDetails: (state, details) => {
    state.releasesPromotionalTextsEditingDialogDetails = details;
  },
  setReleasesPromotionalTextsDetailsDescription: (state, description) => {
    state.releasesPromotionalTextsEditingDialogDetails.description = description;
  },
  setReleasesPromotionalTextsDetailsType: (state, type) => {
    state.releasesPromotionalTextsEditingDialogDetails.type = type;
  },
  setReleasesPromotionalTextsDetailsLanguage: (state, language) => {
    state.releasesPromotionalTextsEditingDialogDetails.language = language;
  },

  // OTHER IDS Panel
  setReleasesOtherIds: (state, value) => {
    state.releasesOtherIds = value;
  },
  setReleasesOtherIdsSearch: (state, value) => {
    state.releasesOtherIdsSearch = value;
  },
  // Editing
  setSelectedReleasesOtherIds: (state, value) => {
    state.selectedReleasesOtherIds = value;
  },
  setShowReleasesOtherIdsEditingDialog: (state, value) => {
    state.showReleasesOtherIdsEditingDialog = value;
  },
  setDefaultReleasesOtherIds: (state) => {
    state.defaultReleasesOtherIds = DEFAULT_OTHER_IDS;
  },
  setReleasesOtherIdsEditingDialogDetails: (state, value) => {
    state.releasesOtherIdsEditingDialogDetails = value;
  },
  setReleasesOtherIdsDetailsSourceAlvId: (state, value) => {
    state.releasesOtherIdsEditingDialogDetails.sourceAlvId = value;
  },
  setReleasesOtherIdsDetailsOtherId: (state, value) => {
    state.releasesOtherIdsEditingDialogDetails.otherId = value;
  },

  // COSTS Panel
  setReleasesCosts: (state, costs) => {
    state.releasesCosts = costs;
  },
  setSelectedReleasesFilterCostGroup: (state, selected) => {
    state.selectedReleasesFilterCostGroup = selected;
  },
  // Editing
  setSelectedReleasesCosts: (state, selected) => {
    state.selectedReleasesCosts = selected;
  },
  setDefaultReleasesCosts: (state) => {
    state.defaultReleasesCosts = DEFAULT_COSTS;
  },
  setShowReleasesCostsEditingDialog: (state, show) => {
    state.showReleasesCostsEditingDialog = show;
  },
  setReleasesCostsEditingDialogDetails: (state, details) => {
    state.releasesCostsEditingDialogDetails = details;
  },
  setReleasesCostsDetailsAmount: (state, amount) => {
    state.releasesCostsEditingDialogDetails.amount = amount;
  },
  // setReleasesCostsDetailsBillable:     (state, billable)    => { state.releasesCostsEditingDialogDetails.billable = billable },
  setReleasesCostsDetailsCostGroup: (state, group) => {
    state.releasesCostsEditingDialogDetails.costGroup = group;
  },
  setReleasesCostsDetailsCountry: (state, country) => {
    state.releasesCostsEditingDialogDetails.country = country;
  },
  setReleasesCostsDetailsDate: (state, date) => {
    state.releasesCostsEditingDialogDetails.date = date;
  },
  setReleasesCostsDetailsDescription: (state, description) => {
    state.releasesCostsEditingDialogDetails.description = description;
  },
  setReleasesCostsDetailsDocumentNumber: (state, number) => {
    state.releasesCostsEditingDialogDetails.documentNumber = number;
  },
  setReleasesCostsDetailsPaidOn: (state, date) => {
    state.releasesCostsEditingDialogDetails.paidOn = date;
  },
  setReleasesCostsDetailsRecipient: (state, recipient) => {
    state.releasesCostsEditingDialogDetails.recipient = recipient;
  },
  setReleasesCostsRecipientOptions: (state, options) => {
    state.releasesCostsRecipientOptions = options;
  },
  // Costsplitting Function
  setShowReleaseCostsplittingDialog: (state, show) => {
    state.showReleaseCostsplittingDialog = show;
  },
  setDefaultReleaseCostsplittingDialogDetails: (state) => {
    state.defaultReleaseCostsplittingDialogDetails = DEFAULT_COSTSPLITTING_DIALOG_DETAILS;
  },
  setReleaseCostsplittingDialogDetails: (state, details) => {
    state.releaseCostsplittingDialogDetails = details;
  },
  setLabelReleasesCostsplittingDetailsDate: (state, date) => {
    state.releaseCostsplittingDialogDetails.date = date;
  },
  setLabelReleasesCostsplittingDetailsRecipient: (state, recipient) => {
    state.releaseCostsplittingDialogDetails.recipient = recipient;
  },
  setLabelReleasesCostsplittingRecipientOptions: (state, options) => {
    state.labelReleasesCostsplittingRecipientOptions = options;
  },
  setLabelReleasesCostsplittingDetailsDocumentNumber: (state, number) => {
    state.releaseCostsplittingDialogDetails.documentNumber = number;
  },
  setLabelReleasesCostsplittingDetailsAmount: (state, amount) => {
    state.releaseCostsplittingDialogDetails.amount = amount;
  },
  setLabelReleasesCostsplittingDetailsCostGroup: (state, group) => {
    state.releaseCostsplittingDialogDetails.costGroup = group;
  },
  setLabelReleasesCostsplittingDetailsCountry: (state, country) => {
    state.releaseCostsplittingDialogDetails.country = country;
  },
  // Costsplitting Dialog Rows
  setReleaseCostsplittingRows: (state, rows) => {
    state.releaseCostsplittingRows = rows;
  },
  setLabelReleasesCostsplittingDetailsDescription: (state, text) => {
    state.releaseCostsplittingDialogDetails.description = text;
  },
  setLabelReleasesCostsplittingDetailsRelease: (state, release) => {
    state.releaseCostsplittingDialogDetails.release = release;
  },
  setLabelReleasesCostsplittingDetailsShare: (state, share) => {
    state.releaseCostsplittingDialogDetails.share = share;
  },
  setLabelReleasesCostsplittingReleaseOptions: (state, options) => {
    state.labelReleasesCostsplittingReleaseOptions = options;
  },

  // BUDGET Panel
  setReleasesBudget: (state, budget) => {
    state.releasesBudget = budget;
  },
  setSelectedReleasesFilterBudgetGroup: (state, selected) => {
    state.selectedReleasesFilterBudgetGroup = selected;
  },
  // Editing
  setSelectedReleasesBudget: (state, selected) => {
    state.selectedReleasesBudget = selected;
  },
  setDefaultReleasesBudget: (state) => {
    state.defaultReleasesBudget = DEFAULT_BUDGET;
  },
  setShowReleasesBudgetEditingDialog: (state, show) => {
    state.showReleasesBudgetEditingDialog = show;
  },
  setReleasesBudgetEditingDialogDetails: (state, details) => {
    state.releasesBudgetEditingDialogDetails = details;
  },
  setReleasesBudgetDetailsBudgetGroup: (state, group) => {
    state.releasesBudgetEditingDialogDetails.budgetGroup = group;
  },
  setReleasesBudgetDetailsScheduledMonth: (state, month) => {
    state.releasesBudgetEditingDialogDetails.scheduledMonth = month;
  },
  setReleasesBudgetDetailsDescription: (state, text) => {
    state.releasesBudgetEditingDialogDetails.description = text;
  },
  setReleasesBudgetDetailsAmount: (state, amount) => {
    state.releasesBudgetEditingDialogDetails.amount = amount;
  },
  setReleasesBudgetDetailsCountry: (state, country) => {
    state.releasesBudgetEditingDialogDetails.country = country;
  },
  setReleasesBudgetDetailsQuantity: (state, quantity) => {
    state.releasesBudgetEditingDialogDetails.quantity = quantity;
  },

  // PROFIT & LOSS Panel (Read Only)
  setReleasesProfitAndLoss: (state, details) => {
    state.releasesProfitAndLoss = details;
  },
  setReleasesProfitAndLossResult: (state, result) => {
    state.releasesProfitAndLossResult = result;
  },
  setSelectedProfitAndLossFilterCostGroup: (state, selected) => {
    state.selectedProfitAndLossFilterCostGroup = selected;
  },
  setSelectedProfitAndLossFilterIncomeGroup: (state, selected) => {
    state.selectedProfitAndLossFilterIncomeGroup = selected;
  },
  setProfitAndLossFilterDetailsFromMonth: (state, month) => {
    state.profitAndLossFilterDetailsFromMonth = month;
  },
  setProfitAndLossFilterDetailsToMonth: (state, month) => {
    state.profitAndLossFilterDetailsToMonth = month;
  },
  setProfitAndLossIsLoading: (state, isLoading) => {
    state.profitAndLossIsLoading = isLoading;
  },

  //ImageUploader
  setLabelReleasesImageUrl: (state, item) => {
    state.selectedLabelReleases.cover = item;
  },
};

const actions = {
  // FETCH RELEASES LIST
  async fetchLabelReleases({ commit, getters }) {
    commit("setIsLoading", true);

    // check for set filters
    let filterObj = {
      search: getters.getLabelReleasesSearch,
      labelId: getters.getSelectedLabelReleasesLabelsFilter,
      quality: getters.getSelectedLabelReleasesQualityFilter,
      status: getters.getSelectedLabelReleasesDigitalDistributionStatus,
      year: getters.getSelectedLabelReleasesYearFilter,
      countryOfOrigin: getters.getSelectedLabelReleasesCountryOfOriginFilter,
    };

    // create string of filter params for api call
    let paramsString = this._vm.$alvPlugin.createApiUrlFilterString(filterObj);

    // sorting options
    let options = getters.getLabelReleasesServerSideSortingOptions;
    let response = await api.getListData2(
      DIR,
      getters.getCurrentPage,
      options.sortBy,
      options.sortDesc,
      paramsString
    );

    // Get list items from db
    // let response = await api.getListData(DIR, getters.getCurrentPage, paramsString)
    if (
      response === undefined ||
      response.error === 1 ||
      response.list.length === 0
    ) {
      commit("setLabelReleases", []);
      commit("setNoDataText", "lang_GENERAL_MESSAGE_NO_RECORDS_FOUND");
    } else {
      commit("setLabelReleases", response.list);
    }

    this._vm.$alvPlugin.storePagingInformations(
      response.filteredRecords,
      response.currentPage,
      response.totalRecords
    );
    commit("setIsLoading", false);
  },

  // FETCH DETAILS
  async fetchLabelReleasesDetails({ commit, getters, dispatch }, alvId) {
    let values;

    if (alvId === "new") {
      values = JSON.parse(JSON.stringify(getters.getDefaultNewLabelRelease));
      let newReleaseDefaults = await api.getDropdownValues(DIR, "newReleaseDefaults");
      if (newReleaseDefaults && newReleaseDefaults.countryOfOrigin) {
        values.countryOfOrigin = newReleaseDefaults.countryOfOrigin;
      }
      commit("setNoDataText", "lang_GENERAL_MESSAGE_NO_RECORDS_FOUND");
    } else {
      let response = await api.getDetailsById(DIR, alvId);
      if (
        response === undefined ||
        response.length === 0 ||
        response.error === 1
      ) {
        values = {};
      } else {
        values = response;
        if (values.language !== null)
          values.language = values.language.toLowerCase();
      }
    }

    // set digital digital distribution items + checkboxes for the rows
    let platforms = JSON.parse(JSON.stringify(getters.getDigitalPlatforms));
    let digitalDistributionStatus = values.digitalDistributionStatus;

    if (platforms !== undefined && digitalDistributionStatus !== undefined) {
      digitalDistributionStatus.forEach((item) => {
        let index = platforms.findIndex((platform) => {
          return item.alvId === platform.alvId;
        });

        platforms[index] = item; // set prepared data (dates + status + selected)
        if (platforms[index].selected === "yes") {
          state.selectedReleaseDigitalDistributionStatus.push(platforms[index]);
        }
      });
    }

    commit("setReleaseDigitalDistribution", platforms);
    commit("setLabelReleasesDetails", values);
    // Fetch Panels
    dispatch("fetchLabelReleaseTracks");
    dispatch("fetchLabelArtists");
    dispatch("fetchLabelPromotionalTexts");
    dispatch("fetchReleasesOtherIds");
    dispatch("fetchLabelReleasesCosts");
    dispatch("fetchLabelReleasesBudget");

    // Set main performer/artist name depending on legacy data or new artist object
    commit("setLabelReleasesDetailsConnectedArtist", null);
    if (alvId !== "new") {
      let performerName = null
      if (values.performer !== null && values.performer !== undefined) {
        if (typeof values.performer === 'object' && !Array.isArray(values.performer)) {
          performerName = this._vm.$alvPlugin.showNameOfAzEntry(values.performer, true)
        } else {
          performerName = values.performer
        }
      }
      commit("setLabelReleasesDetailsConnectedArtist", performerName);
    }
    dispatch("fetchLabelReleaseLabels");
    commit("setIsLoading", false);
  },

  fetchLabelReleaseLabels({ getters, commit }) {
    commit("setLabelCompanies");
    let labels = [];
    let labelsDropdown = [];
    getters.getLabelCompanies.forEach((labelCompany) => {
      if (labelCompany.labels != null) {
        labels = labels.concat(labelCompany.labels);
      }
    });
    labels.forEach((label) => {
      labelsDropdown.push({
        value: parseInt(label.id),
        text: label.name_alv,
        alvId: label.alvId,
      });
    });
    if (
      labelsDropdown === undefined ||
      labelsDropdown.length === 0 ||
      labelsDropdown.error === 1
    )
      labelsDropdown = [];

    commit("setLabelReleaseLabelsDropdown", labelsDropdown);
  },

  async prepareLabelReleasesEditFormData({ dispatch, commit }) {
    commit("setGenres");
    commit("setLicensors");
    commit("setReleaseGemaMediaTypes");
    commit("setDigitalPlatforms");
  },

  async fetchLabelReleasesPricelistsDropdownValues({ commit }) {
    let items = await api.getDropdownValues(DIR, "releasePricelists");
    commit("setLabelReleasesPricelistsOptions", items);
  },

  // Az Person/Group = Artist Connection (Main artist/performer)
  // DELETE
  async deleteArtistLabelReleasConnection({ commit }) {
    commit("setLabelReleasesDetailsConnectedArtist", null);
    commit("setLabelReleasesDetailsArtist", null);
  },
  // SEARCH
  async searchArtistForReleases({ getters, commit }) {
    let params =
      "search=" +
      getters.getArtistForReleasesSearch +
      "&type=artist&azType=persons,groups";
    let response = await api.getListData("az", "1", params);

    commit(
      "setTotalListedConnectArtistToReleasesDialog",
      response.filteredRecords
    );
    commit(
      "setTotalRecordsConnectArtistToReleasesDialog",
      response.totalRecords
    );

    return response.list;
  },
  // ADD
  async addArtistToReleases({ getters, commit }) {
    let selectedArtist = getters.getSelectedArtistForReleases[0]; // always only 1 artist selected
    let releaseDetails = getters.getLabelReleasesDetails;
    releaseDetails.performer = selectedArtist;
    let azEntityName = this._vm.$alvPlugin.showNameOfAzEntry(
      releaseDetails.performer,
      true
    );
    commit("setLabelReleasesDetailsConnectedArtist", azEntityName);
    commit("setLabelReleasesDetailsArtist", releaseDetails.performer);
    if (
      getters.getLabelReleasesArtistForReleasesConnectToAllTracksCheckbox
        .length !== 0
    ) {
      commit("setSnackbar", {
        type: "success",
        msg: i18n.t("lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON"),
      });
    }
  },

  // ARTISTS Panel
  async fetchLabelArtists({ commit, getters }) {
    let artistsFromDb = getters.getLabelReleasesDetails.artists;

    if (artistsFromDb === undefined || artistsFromDb === null)
      artistsFromDb = [];
    else if (artistsFromDb.length === 0)
      commit("setNoDataText", "lang_GENERAL_MESSAGE_NO_RECORDS_FOUND");

    commit("setReleasesArtists", artistsFromDb);
  },
  // AUTOCOMPLETE: Artist
  async fetchAutocompleteReleasesArtistsArtist({ commit }, input) {
    let response = await api.getAutocompleteSearch("az/persons", input);
    commit("setReleasesArtistsArtistOptions", response.list);
  },
  // DELETE Artist
  async deleteSelectedReleasesArtists({ getters, commit }) {
    let selectedArtist = getters.getSelectedReleasesArtists;
    let index = getters.getReleasesArtists.findIndex(
      (artist) => artist.id === selectedArtist.id
    );

    let startAmount = getters.getReleasesArtists.length;
    Vue.delete(getters.getReleasesArtists, index);
    let newAmount = getters.getReleasesArtists.length;

    if (startAmount > newAmount) {
      commit("setSnackbar", {
        type: "success",
        msg:
          i18n.t("lang_LABEL_RELEASES_SNACKBAR_DELETE_ARTIST_SUCCESSFUL") +
          "<br />" +
          i18n.t("lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON"),
        timeout: -1,
      });
    } else {
      commit("setSnackbar", {
        type: "error",
        msg: i18n.t(
          "lang_LABEL_RELEASES_SNACKBAR_DELETE_ARTIST_NOT_SUCCESSFUL"
        ),
      });
    }

    commit("setSelectedReleasesArtists", []);
    if (newAmount === 0)
      commit("setNoDataText", "lang_GENERAL_MESSAGE_NO_RECORDS_FOUND");
  },

  // PROMOTIONAL TEXTS Panel
  async fetchLabelPromotionalTexts({ commit, getters }) {
    let textsFromDb = getters.getLabelReleasesDetails.promotionalTexts;

    if (textsFromDb === undefined || textsFromDb === null) textsFromDb = [];
    else if (textsFromDb.length === 0)
      commit("setNoDataText", "lang_GENERAL_MESSAGE_NO_RECORDS_FOUND");

    commit("setReleasesPromotionalTexts", textsFromDb);
  },
  // DELETE
  async deleteSelectedReleasesPromotionalTexts({ getters, commit }) {
    let selectedText = getters.getSelectedReleasesPromotionalTexts;
    let index = getters.getReleasesPromotionalTexts.findIndex(
      (text) => text.id === selectedText.id
    );

    let startAmount = getters.getReleasesPromotionalTexts.length;
    Vue.delete(getters.getReleasesPromotionalTexts, index);
    let newAmount = getters.getReleasesPromotionalTexts.length;

    if (startAmount > newAmount) {
      commit("setSnackbar", {
        type: "success",
        msg:
          i18n.t(
            "lang_LABEL_RELEASES_SNACKBAR_DELETE_PROMOTIONAL_TEXT_SUCCESSFUL"
          ) +
          "<br />" +
          i18n.t("lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON"),
        timeout: -1,
      });
    } else {
      commit("setSnackbar", {
        type: "error",
        msg: i18n.t(
          "lang_LABEL_RELEASES_SNACKBAR_DELETE_PROMOTIONAL_TEXT_NOT_SUCCESSFUL"
        ),
      });
    }

    commit("setSelectedReleasesPromotionalTexts", []);
    if (newAmount === 0)
      commit("setNoDataText", "lang_GENERAL_MESSAGE_NO_RECORDS_FOUND");
  },

  // OTHER IDS Panel
  async fetchReleasesOtherIds({ commit, getters }) {
    let idsFromDb = getters.getLabelReleasesDetails.otherIds;

    if (idsFromDb === undefined || idsFromDb === null) idsFromDb = [];
    else if (idsFromDb.length === 0)
      commit("setNoDataText", "lang_GENERAL_MESSAGE_NO_RECORDS_FOUND");

    commit("setReleasesOtherIds", idsFromDb);
  },
  // DELETE
  async deleteSelectedReleasesOtherIds({ getters, commit }) {
    let selectedId = getters.getSelectedReleasesOtherIds; // only one id is passed
    let index = getters.getReleasesOtherIds.findIndex(
      (id) => JSON.stringify(id) === JSON.stringify(selectedId)
    );

    let startAmount = getters.getReleasesOtherIds.length;
    if (index !== -1) Vue.delete(getters.getReleasesOtherIds, index);
    let newAmount = getters.getReleasesOtherIds.length;

    if (startAmount > newAmount) {
      commit("setSnackbar", {
        type: "success",
        msg:
          i18n.t("lang_GENERIC_SNACKBAR_DELETE_SUCCESSFUL") +
          "<br />" +
          i18n.t("lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON"),
        timeout: -1,
      });
    } else {
      commit("setSnackbar", {
        type: "error",
        msg: i18n.t("lang_GENERIC_SNACKBAR_DELETE_NOT_SUCCESSFUL"),
      });
    }

    commit("setSelectedReleasesOtherIds", []);
    if (newAmount === 0)
      commit("setNoDataText", "lang_GENERAL_MESSAGE_NO_RECORDS_FOUND");
  },

  // TRACKS Panel
  async fetchLabelReleaseTracks({ commit, getters }) {
    let tracksFromDB = await getters.getLabelReleasesDetails.tracksOnRelease;
    if (tracksFromDB === undefined) tracksFromDB = null;
    commit("setLabelReleaseTracks", tracksFromDB);
  },
  // DELETE Track
  async deleteSelectedLabelReleaseTrack({ getters, commit }) {
    let selectedTrackAlvId = getters.getSelectedLabelReleaseTrack;
    let selectedDisc = getters.getLabelReleasesTracksSelectedDisc;
    let tracksOfDisc = getters.getLabelReleaseTracks[selectedDisc];
    let index = tracksOfDisc.findIndex(
      (track) => track.alvId === selectedTrackAlvId
    );

    // adjust all the track positions after the deleted track
    for (let i = index + 1; i < tracksOfDisc.length; i++) {
      tracksOfDisc[i].trackPosition = tracksOfDisc[i].trackPosition - 1;
    }

    // delete track in FE
    let startAmount = tracksOfDisc.length;
    Vue.delete(tracksOfDisc, index);
    let endAmount = tracksOfDisc.length;

    if (startAmount > endAmount) {
      commit("setSnackbar", {
        type: "success",
        msg:
          i18n.t("lang_LABEL_RELEASES_SNACKBAR_DELETE_TRACK_SUCCESSFUL") +
          "<br />" +
          i18n.t("lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON"),
        timeout: -1,
      });
      // set new number of tracks
      // let length = getters.getLabelReleasesDetailsTracksNumber-1
      // commit('setLabelReleasesDetailsTracksNumber', length)
    } else {
      commit("setSnackbar", {
        type: "error",
        msg: i18n.t("lang_LABEL_RELEASES_SNACKBAR_DELETE_TRACK_NOT_SUCCESSFUL"),
      });
    }
  },
  // SEARCH Tracks
  async searchLabelReleaseTrack({ getters }) {
    let dir = "label/tracks";
    let selectedDisc = getters.getLabelReleasesTracksSelectedDisc;
    let allTracks = getters.getLabelReleaseTracks;
    let tracksOfDisc = allTracks[selectedDisc];
    let params = "search=" + getters.getLabelReleaseTrackSearch;

    
    let existingTrackAlvIds = {};
    if (Object.keys(allTracks).length !== 0) {
      let length = Object.keys(allTracks).length;

      for (let i = 1; i <= length + 1; i++) {
        if (allTracks[i] !== undefined) {
          allTracks[i].forEach((track) => {
            // Add ALV id key to object
            existingTrackAlvIds[track.alvId] = true;
          });
        }
      }
    }

    let response = await api.getFilteredResults(dir, params);
    if (response.list && response.list.length > 0) {
      for (let i = 0; i < response.list.length; i++) {
        let alvId = response.list[i]['alvId']
        if (alvId && existingTrackAlvIds[alvId] === true) {
          response.list[i]['alvInternalDisable'] = true
        }
      }
    }
    return response.list;
  },
  // ADD Tracks
  async addTracksToRelease({ getters, commit }, selectedItems) {
    let soundCarrierNumber = getters.getLabelReleasesTracksSelectedDisc;
    let tracks = getters.getLabelReleaseTracks[soundCarrierNumber];
    let trackPosition;

    // If disc is new, set to empty array
    if (tracks === undefined) tracks = [];
    let tracksLength = tracks.length;

    if (tracksLength) {
      trackPosition = tracks[tracks.length - 1].trackPosition;
    } else {
      trackPosition = 0;
    }

    selectedItems.forEach((item, i) => {
      let track = item;
      track.soundCarrierNumber = soundCarrierNumber;
      track.trackPosition = trackPosition + i + 1;

      tracks.push(item);
    });

    // let newNumberOfTracks = getters.getLabelReleasesDetailsTracksNumber+1
    // commit('setLabelReleasesDetailsTracksNumber', newNumberOfTracks)
    commit("setSpecificLabelReleaseTracks", tracks);

    return {
      error: tracksLength < length ? -1 : 1,
    };
  },

  // DISTRIBUTION Panel
  async fetchReleaseDigitalDistribution({ getters, commit }) {
    let digitalDistribution =
      getters.getLabelReleasesDetails.digitalDistributionStatus;
    commit("setIsLoading", false);

    if (digitalDistribution === undefined || digitalDistribution.length === 0)
      commit("setNoDataText", "lang_GENERAL_MESSAGE_NO_RECORDS_FOUND");
    commit("setReleaseDigitalDistribution", digitalDistribution);
  },

  // COSTS Panel
  async fetchLabelReleasesCosts({ getters, commit }) {
    let costs = getters.getLabelReleasesDetails.costs;
    commit("setIsLoading", false);

    if (costs === undefined) {
      commit("setNoDataText", "lang_GENERAL_MESSAGE_NO_RECORDS_FOUND");
      costs = [];
    }

    commit("setReleasesCosts", costs);
  },
  // EXPORT all
  async exportAllReleasesCosts({ commit, getters }) {
    let queryParams = { action: "export" };
    let dir = DIR + "/" + getters.getLabelReleasesDetailsAlvId + "/costs";
    let response = await api.triggerAction(dir, {}, queryParams);

    if (response.error === -1) {
      api.getFileFromALV(response.response.path);
      commit("setSnackbar", {
        type: "success",
        msg: i18n.t("lang_GENERIC_SNACKBAR_DOWNLOAD_SUCCESSFULL"),
      });
    }

    if (response.error === 1) {
      commit("setSnackbar", {
        type: "error",
        msg: i18n.t("lang_GENERIC_SNACKBAR_DOWNLOAD_NOT_SUCCESSFULL"),
      });
    }
  },
  // DELETE Costs
  async deleteSelectedReleasesCosts({ getters, commit }) {
    let selectedCost = getters.getSelectedReleasesCosts;
    let index = getters.getReleasesCosts.findIndex(
      (text) => text.id === selectedCost.id
    );

    let startAmount = getters.getReleasesCosts.length;
    Vue.delete(getters.getReleasesCosts, index);
    let newAmount = getters.getReleasesCosts.length;

    if (startAmount > newAmount) {
      commit("setSnackbar", {
        type: "success",
        msg:
          i18n.t("lang_GENERIC_SNACKBAR_DELETE_SUCCESSFUL") +
          "<br />" +
          i18n.t("lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON"),
        timeout: -1,
      });
    } else {
      commit("setSnackbar", {
        type: "error",
        msg: i18n.t("lang_GENERIC_SNACKBAR_DELETE_NOT_SUCCESSFUL"),
      });
    }

    commit("setSelectedReleasesCosts", []);
    if (newAmount === 0)
      commit("setNoDataText", "lang_GENERAL_MESSAGE_NO_RECORDS_FOUND");
  },
  // FETCH Recipient
  async fetchAutocompleteReleasesCostsRecipient({ commit }, input) {
    let response = await api.getAutocompleteSearch("az/persons", input);
    commit("setReleasesCostsRecipientOptions", response.list);
  },
  // COSTSPLITTING
  // FETCH costsplitting recipient
  async fetchAutocompleteLabelReleasesCostsplittingRecipient(
    { commit },
    input
  ) {
    let response = await api.getAutocompleteSearch("az/persons", input);
    commit("setLabelReleasesCostsplittingRecipientOptions", response.list);
  },
  // AUTOCOMPLETE costsplitting releases
  async fetchAutocompleteLabelReleasesCostsplittingRelease({ commit }, input) {
    let response = await api.getAutocompleteSearch(DIR, input);
    commit("setLabelReleasesCostsplittingReleaseOptions", response.list);
  },
  // add new line
  async addNewLineCostsplittingRows({ getters, commit }) {
    let rows = getters.getReleaseCostsplittingRows;
    let id = -(1000 + Math.floor(Math.random() * 123));
    let release = getters.getLabelReleasesCostsplittingDetailsRelease;
    let description = getters.getLabelReleasesCostsplittingDetailsDescription;
    let amount = getters.getLabelReleasesCostsplittingDetailsAmount;
    let share = getters.getLabelReleasesCostsplittingDetailsShare;
    if (share !== null && share !== "") {
      share = JSON.parse(
        JSON.stringify(this._vm.$alvPlugin.stringToFloat(share))
      );
    } else share === i18n.n(0, "number");

    if (amount !== null && amount !== "") {
      amount = JSON.parse(
        JSON.stringify(this._vm.$alvPlugin.stringToFloat(amount))
      );
    } else amount === i18n.n(0, "number");

    // Calculate pro rata amount
    let proRataAmount = 0;
    let tempProRataAmount = amount * share;
    if (tempProRataAmount !== 0) proRataAmount = tempProRataAmount / 100;
    // Add row
    rows.push({
      id: id,
      release: release,
      description: description,
      share: share,
      proRataAmount: proRataAmount,
    });
  },
  // delete Line
  async deleteLineCostsplittingRows({ getters }, item) {
    let index = getters.getReleaseCostsplittingRows.findIndex(
      (row) => row.id === item.id
    );
    Vue.delete(getters.getReleaseCostsplittingRows, index);
  },
  // do the COSTSPLITTING
  async labelReleasesSplittingCosts({ getters, commit, dispatch }) {
    let alvId = getters.getLabelReleasesDetailsAlvId;
    let queryParams = { action: "costsplitting" };
    let metaData = {
      date: getters.getLabelReleasesCostsplittingDetailsDate,
      recipient: getters.getLabelReleasesCostsplittingDetailsRecipient,
      documentNumber:
        getters.getLabelReleasesCostsplittingDetailsDocumentNumber,
      amount: getters.getLabelReleasesCostsplittingDetailsAmount,
      costGroup: getters.getLabelReleasesCostsplittingDetailsCostGroup,
      country: getters.getLabelReleasesCostsplittingDetailsCountry,
      rows: getters.getReleaseCostsplittingRows,
    };

    let response = await api.triggerAction(
      DIR + "/" + alvId + "/costs",
      metaData,
      queryParams
    );

    commit("setShowReleaseCostsplittingDialog", false);
    if (response.error === -1) {
      dispatch("fetchLabelReleasesDetails", response.response.alvId);
      commit("setSnackbar", {
        type: "success",
        msg: i18n.t("lang_LABEL_RELEASES_COSTSPLITTING_SUCCESS"),
      });
    } else {
      commit("setSnackbar", {
        type: "error",
        msg: i18n.t("lang_LABEL_RELEASES_COSTSPLITTING_NOT_SUCCESSFUL"),
      });
    }
  },

  // BUDGET Panel
  async fetchLabelReleasesBudget({ getters, commit }) {
    let budget = getters.getLabelReleasesDetails.budget;
    commit("setIsLoading", false);

    if (budget === undefined) {
      commit("setNoDataText", "lang_GENERAL_MESSAGE_NO_RECORDS_FOUND");
      budget = [];
    }

    commit("setReleasesBudget", budget);
  },
  // EXPORT all budget
  async exportAllReleasesBudget({ getters, commit }) {
    let queryParams = { action: "export" };
    let dir = DIR + "/" + getters.getLabelReleasesDetailsAlvId + "/budget";
    let response = await api.triggerAction(dir, {}, queryParams);

    if (response.error === -1) {
      api.getFileFromALV(response.response.path);
      commit("setSnackbar", {
        type: "success",
        msg: i18n.t("lang_GENERIC_SNACKBAR_DOWNLOAD_SUCCESSFULL"),
      });
    }

    if (response.error === 1) {
      commit("setSnackbar", {
        type: "error",
        msg: i18n.t("lang_GENERIC_SNACKBAR_DOWNLOAD_NOT_SUCCESSFULL"),
      });
    }
  },
  // DELETE Budget
  async deleteSelectedReleasesBudget({ getters, commit }) {
    let selectedCost = getters.getSelectedReleasesBudget;
    let index = getters.getReleasesBudget.findIndex(
      (text) => text.id === selectedCost.id
    );

    let startAmount = getters.getReleasesBudget.length;
    Vue.delete(getters.getReleasesBudget, index);
    let newAmount = getters.getReleasesBudget.length;

    if (startAmount > newAmount) {
      commit("setSnackbar", {
        type: "success",
        msg:
          i18n.t("lang_GENERIC_SNACKBAR_DELETE_SUCCESSFUL") +
          "<br />" +
          i18n.t("lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON"),
        timeout: -1,
      });
    } else {
      commit("setSnackbar", {
        type: "error",
        msg: i18n.t("lang_GENERIC_SNACKBAR_DELETE_NOT_SUCCESSFUL"),
      });
    }

    commit("setSelectedReleasesBudget", []);
    if (newAmount === 0)
      commit("setNoDataText", "lang_GENERAL_MESSAGE_NO_RECORDS_FOUND");
  },

  // PROFIT AND LOSS Panel
  async fetchReleaseProfitAndLoss({ getters, commit }) {
    commit("setProfitAndLossIsLoading", true);
    let fromMonth = getters.getProfitAndLossFilterDetailsFromMonth;
    let ToMonth = getters.getProfitAndLossFilterDetailsToMonth;
    let releaseAlvId = getters.getLabelReleasesDetailsAlvId;
    let params = "fromMonth=" + fromMonth + "&toMonth=" + ToMonth;

    let response = await api.getProfitAndLossResult(
      DIR + "/" + releaseAlvId + "/profitAndLoss",
      params
    );

    if (response === null || response.error === 1) {
      commit("setSnackbar", {
        type: "error",
        msg: this._vm.$alvPlugin.isLangConst(response.response.errorMsg)
          ? $t(response.response.errorMsg)
          : response.response.errorMsg,
      });
    } else {
      commit("setReleasesProfitAndLoss", response.profitAndLoss);
      commit("setReleasesProfitAndLossResult", response.profitAndLoss.result);
    }
    commit("setProfitAndLossIsLoading", false);
  },
  async getFilteredProfitAndLoss({ getters, commit }) {
    let fromMonth = getters.getProfitAndLossFilterDetailsFromMonth;
    let ToMonth = getters.getProfitAndLossFilterDetailsToMonth;
    let releaseAlvId = getters.getLabelReleasesDetailsAlvId;
    let params = "fromMonth=" + fromMonth + "&toMonth=" + ToMonth;

    let response = await api.getProfitAndLossResult(
      DIR + "/" + releaseAlvId + "/profitAndLoss",
      params
    );

    if (response === null || response.error === 1) {
      commit("setSnackbar", {
        type: "error",
        msg: this._vm.$alvPlugin.isLangConst(response.response.errorMsg)
          ? $t(response.response.errorMsg)
          : response.response.errorMsg,
      });
    } else result = response.result;

    commit("setProfitAndLossResult", result);
  },
  //EXPORT PROFIT&LOSS DATA
  async exportProfitAndLossData({ commit, getters }) {
    let metaData = {
      fromMonth: getters.getProfitAndLossFilterDetailsFromMonth,
      toMonth: getters.getProfitAndLossFilterDetailsToMonth,
    };
    let alvId = getters.getExpandedLabelReleases[0].alvId;
    let queryParams = { action: "export" };

    let response = await api.triggerAction(
      DIR + "/" + alvId + "/profitAndLoss",
      metaData,
      queryParams
    );

    if (response === 1 || response == undefined || response.error === 1) {
      commit("setSnackbar", {
        type: "error",
        msg: this._vm.$alvPlugin.isLangConst(response.response.errorMsg)
          ? i18n.t(response.response.errorMsg)
          : response.response.errorMsg,
      });
    } else {
      api.getFileFromALV(response.response.path);
      commit("setSnackbar", {
        type: "success",
        msg: i18n.t("lang_GENERAL_SNACKBAR_DOWNLOAD_SUCCESSFULL"),
      });
    }
  },

  // SAVE EDIT FORM
  async saveLabelReleasesForm({ commit, getters, dispatch }) {
    let alvId = getters.getLabelReleasesDetailsAlvId;
    let metaData = getters.getLabelReleasesDetails;
    let isNew = router.currentRoute.params.alvId == "new";

    // Panel Data
    metaData["digitalDistributionStatus"] =
      getters.getReleaseDigitalDistribution;
    metaData["artists"] = getters.getReleasesArtists;
    metaData["promotionalTexts"] = getters.getReleasesPromotionalTexts;
    // new rows get a temporary negative id from the editing dialog; backend generates the real id
    metaData["otherIds"] = (getters.getReleasesOtherIds || []).map((otherId) => ({
      ...otherId,
      id: otherId.id > 0 ? otherId.id : null,
    }));
    metaData["costs"] = getters.getReleasesCosts;

    if (
      getters.getLabelReleasesArtistForReleasesConnectToAllTracksCheckbox[0] ===
      "connectToAllTracks"
    ) {
      metaData["connectPerformerToAllTracks"] = true;
    }

    let response = await api.saveEditForm(DIR, alvId, metaData, isNew);

    if (
      response === undefined ||
      response.length === 0 ||
      response.error === 1
    ) {
      // response = []
      commit("setSnackbar", {
        type: "error",
        // msg: i18n.t('lang_LABEL_RELEASES_SNACKBAR_RELEASE_NOT_SAVED'),
        msg: this._vm.$alvPlugin.isLangConst(response.response.errorMsg)
          ? i18n.t(response.response.errorMsg)
          : response.response.errorMsg,
      });
    } else {
      commit("setSnackbar", {
        type: "success",
        msg: i18n.t("lang_LABEL_RELEASES_SNACKBAR_RELEASE_SAVED"),
      });

      if (isNew) {
        router.push({
          name: "LabelReleasesEdit",
          params: { alvId: response.response.alvId },
        });
      }
      await dispatch("fetchLabelReleasesDetails", response.response.alvId);
      commit("setLabelReleasesArtistForReleasesConnectToAllTracksCheckbox", []);
      commit("setLabelReleasesArtistsPanelConnectToAllTracksCheckbox", null);
      dispatch("fetchLabelReleaseTracks");
    }
  },

  // ACTIONS Switch
  async doLabelReleasesAction({ commit, dispatch, getters }) {
    if (state.selectedLabelReleases.length > 0) {
      switch (state.selectedLabelReleasesAction) {
        case "ddexExport":
          dispatch("ddexReleaseExport");
          break;
        case "delete":
          commit("setShowDeletionDialog", true);
          break;
        case "replaceTags":
          commit("setShowManageTagsDialog", true);
          break;
        case "labelCopyExcel":
          dispatch("releaseLabelCopy", { context: "labelCopyExcel" });
          break;
        case "labelCopyPdf":
          dispatch("releaseLabelCopy", { context: "labelCopyPdf" });
          break;
        case "gvlExcel":
          dispatch("gvlTrisysExcel");
          break;
        case "gemaTonis":
          if (state.selectedLabelReleases.length === 1) {
            dispatch("gemaTonisExcel");
          } else {
            commit(
              "setSelectionRequiredText",
              "lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_ONLY_ONE"
            );
            commit("setShowSelectionRequiredDialog", true);
          }
          break;
        case "copyWithTracks":
        case "copyWithoutTracks":
          if (state.selectedLabelReleases.length === 1) {
            dispatch("copyLabelRelease");
          } else {
            commit(
              "setSelectionRequiredText",
              "lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_ONLY_ONE"
            );
            commit("setShowSelectionRequiredDialog", true);
          }
          break;
        case "export":
          if (state.selectedLabelReleases.length > 0) {
            commit("setLabelReleasesExportAll", false);
            commit("setShowLabelReleasesExportDialog", true);
          } else {
            commit(
              "setSelectionRequiredText",
              "lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_AT_LEAST_ONE"
            );
            commit("setShowSelectionRequiredDialog", true);
          }
          break;
        case "testRelease":
          if (state.selectedLabelReleases.length == 1) {
            dispatch("fetchTestReleaseCalculation");
          } else {
            commit(
              "setSelectionRequiredText",
              "lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_ONLY_ONE"
            );
            commit("setShowSelectionRequiredDialog", true);
          }
          break;
        case "prepareReleaseForDelivery":
          if (state.selectedLabelReleases.length === 1) {
            if (getters.getDigitalDistributionIsBooked === "yes")
              dispatch("prepareLabelReleaseDelivery");
            else {
              commit(
                "setSelectionRequiredText",
                "lang_LABEL_RELEASES_DIGITAL_DISTRIBUTION_TOOLTIP_SWITCHNOW"
              );
              commit("setShowSelectionRequiredDialog", true);
            }
          } else {
            commit(
              "setSelectionRequiredText",
              "lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_ONLY_ONE"
            );
            commit("setShowSelectionRequiredDialog", true);
          }

          break;
      }
    } else {
      commit(
        "setSelectionRequiredText",
        state.selectedLabelReleasesAction == "testRelease"
          ? "lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_ONLY_ONE"
          : "lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_AT_LEAST_ONE"
      );
      commit("setShowSelectionRequiredDialog", true);
    }
  },

  async fetchTestReleaseCalculation({ commit, getters }) {
    let response = await api.getSpecificFormData(
      DIR + '/testCalculation'
    );

    if (response.error === -1) {
      var data = response.response;
      data.net = data.net != null ? i18n.n(data.net, "number") : data.net;
      data.quantity = data.quantity  != null? i18n.n(data.quantity, "number") : data.quantity;
      data.ppd = data.ppd != null ? i18n.n(data.ppd, "number") : data.ppd;
      data.msp = data.msp != null ? i18n.n(data.msp, "number") : data.msp;

      commit("setTestCalculationReleaseDetailsLicenses", data.licenses);
      commit("setTestCalculationReleaseDetailsSalesType", data.salesType);
      commit("setTestCalculationReleaseDetailsCountry", data.country);
      commit("setTestCalculationReleaseDetailsNet", data.net);
      commit("setTestCalculationReleaseDetailsQuantity", data.quantity);
      commit("setTestCalculationReleaseDetailsPpd", data.ppd);
      commit("setTestCalculationReleaseDetailsMsp", data.msp);
      commit("setTestCalculationReleaseDetailsIsrc", data.isrc);

      // set form values and show dialog
      commit("setLabelTestReleasesDialog", true);
      commit("setTestCalculationReleaseForm", response.response);
    } else {
      commit("setSnackbar", {
        type: "error",
        msg: "Es ist ein Fehler aufgetreten", // TODO: lang const from BE or FE?!
      });
    }
  },
  // Calculate
  async calculateLabelReleaseTestCalculation({ getters, commit }) {
    let queryParams = {
      action: "testCalculation"
    };
    let metaData = {};
    metaData.licenses = getters.getTestCalculationReleaseDetailsLicenses;
    metaData.salesType = getters.getTestCalculationReleaseDetailsSalesType;
    metaData.country = getters.getTestCalculationReleaseDetailsCountry;
    metaData.net = getters.getTestCalculationReleaseDetailsNet;
    metaData.quantity = getters.getTestCalculationReleaseDetailsQuantity;
    metaData.ppd = getters.getTestCalculationReleaseDetailsPpd;
    metaData.msp = getters.getTestCalculationReleaseDetailsMsp;
    metaData.isrc = getters.getTestCalculationReleaseDetailsIsrc;
    metaData["releaseIds"] = getters.getSelectedLabelReleases;

    let response = await api.triggerAction(DIR, metaData, queryParams);
    if (response.error === -1) {
      commit("setLabelReleaseTestCalculationResult", response.response);
    } else {
      commit("setLabelReleaseTestCalculationErrorMessage", response.response.errorMsg);
    }
  },
  // Action: DELETE
  async deleteSelectedLabelReleases({ commit, getters, dispatch }) {
    const response = await api.deleteEntries(
      DIR,
      getters.getSelectedLabelReleases
    );
    if (response.error === -1) {
      for (let i = 0; i < getters.getSelectedLabelReleases.length; i++) {
        let index = getters.getLabelReleases.findIndex(
          (release) => release.alvId == getters.getSelectedLabelReleases[i]
        );
        Vue.delete(getters.getLabelReleases, index);
      }

      commit("setSnackbar", {
        type: "success",
        msg: i18n.t("lang_GENERIC_SNACKBAR_ENTRY_DELETED"),
      });

      commit("setSelectedLabelReleases", []);
      commit("setSelectedLabelReleasesAction", []);
      dispatch("fetchLabelReleases");
    } else {
      // in case of failed deletion, i.e. when release is connected to an invoice or inventory
      console.log(response);
      let errorMsg = response.response.errorMsg;
      if (errorMsg !== undefined) {
        commit("setSnackbar", {
          type: "error",
          msg: this._vm.$alvPlugin.isLangConst(errorMsg)
            ? i18n.t(errorMsg)
            : errorMsg,
        });
      }
    }
  },

  // Action: LABELCOPY
  async releaseLabelCopy({ getters, commit }, param) {
    let queryParams = { action: param.context };
    let metaData = { releaseIds: getters.getSelectedLabelReleases };

    let response = await api.triggerAction(DIR, metaData, queryParams);

    if (response.error === -1) {
      if (response.response.path !== null) {
        api.getFileFromALV(response.response.path);
        commit("setSnackbar", {
          type: "success",
          msg: i18n.t("lang_GENERAL_SNACKBAR_DOWNLOAD_SUCCESSFULL"),
        });
      }
    } else {
      let errorMsg = response.response.errorMsg;
      if (errorMsg !== undefined) {
        commit("setSnackbar", {
          type: "error",
          msg: this._vm.$alvPlugin.isLangConst(errorMsg)
            ? i18n.t(errorMsg)
            : errorMsg,
        });
      }
    }
  },

  async ddexReleaseExport({ getters, commit }) {
    let queryParams = { action: "ddexExport" };
    let metaData = { releaseIds: getters.getSelectedLabelReleases };

    // commit("setShowReleaseDeliveryDialog", true);
    let response = await api.triggerAction(DIR, metaData, queryParams);

    if (response.error === -1) {
      if (response.response.path !== null) {
        api.getFileFromALV(response.response.path);
        commit("setSnackbar", {
          type: "success",
          msg: i18n.t("lang_GENERAL_SNACKBAR_DOWNLOAD_SUCCESSFULL"),
        });
      }
    } else {
      let errorMsg = response.response.errorMsg[0].message;
      if (errorMsg !== undefined) {
        commit("setSnackbar", {
          type: "error",
          msg: this._vm.$alvPlugin.isLangConst(errorMsg)
            ? i18n.t(errorMsg)
            : errorMsg,
        });
      }
    }
  },

  // Action: COPY
  async copyLabelRelease({ getters, commit, dispatch }) {
    let queryParams = { action: getters.getSelectedLabelReleasesAction };
    let metaData = { releaseIds: getters.getSelectedLabelReleases };

    let response = await api.triggerAction(DIR, metaData, queryParams);

    if (response.error === -1) {
      commit("setSnackbar", {
        type: "success",
        msg: i18n.t("lang_GENERAL_SNACKBAR_COPY_SUCCESSFULL"),
      });
      dispatch("fetchLabelReleases");
    } else {
      let errorMsg = response.response.errorMsg;
      if (errorMsg !== undefined) {
        commit("setSnackbar", {
          type: "error",
          msg: this._vm.$alvPlugin.isLangConst(errorMsg)
            ? i18n.t(errorMsg)
            : errorMsg,
        });
      }
    }
  },

  // Action: EXPORT ALL
  async exportAllLabelReleases({ commit, getters }) {
    commit("setIsLoading", true);
    let queryParams = {
      action: "export",
      type: "excel",
      tracks: getters.getLabelReleasesExportWithTracks ? "yes" : "no",
    };

    let metaData = { releaseIds: [] };

    let response = await api.triggerAction(DIR, metaData, queryParams);
    if (response.error === -1) {
      if (response.response.path !== null) {
        api.getFileFromALV(response.response.path);
        commit("setSnackbar", {
          type: "success",
          msg: i18n.t("lang_GENERAL_SNACKBAR_DOWNLOAD_SUCCESSFULL"),
        });
      }
    } else {
      let errorMsg = response.response.errorMsg;
      if (errorMsg !== undefined) {
        commit("setSnackbar", {
          type: "error",
          msg: this._vm.$alvPlugin.isLangConst(errorMsg)
            ? i18n.t(errorMsg)
            : errorMsg,
        });
      }
    }
    commit("setLabelReleasesExportWithTracks", false);
    commit("setIsLoading", false);
  },
  // Action: EXPORT SELECTED
  async exportSelectedLabelReleases({ commit, getters }) {
    commit("setIsLoading", true);
    let queryParams = {
      action: "export",
      type: "excel",
      tracks: getters.getLabelReleasesExportWithTracks ? "yes" : "no",
    };

    let metaData = { alvIds: getters.getSelectedLabelReleases };

    let response = await api.triggerAction(DIR, metaData, queryParams);
    if (response.error === -1) {
      if (response.response.path !== null) {
        api.getFileFromALV(response.response.path);
        commit("setSnackbar", {
          type: "success",
          msg: i18n.t("lang_GENERAL_SNACKBAR_DOWNLOAD_SUCCESSFULL"),
        });
      }
    } else {
      let errorMsg = response.response.errorMsg;
      if (errorMsg !== undefined) {
        commit("setSnackbar", {
          type: "error",
          msg: this._vm.$alvPlugin.isLangConst(errorMsg)
            ? i18n.t(errorMsg)
            : errorMsg,
        });
      }
    }
    commit("setLabelReleasesExportWithTracks", false);
    commit("setIsLoading", false);
  },
  // ACTION Export (type - mappings)
  async exportLabelReleasesMapping({ commit, getters }) {
    let queryParams = {
      action: "export",
      type: "mappings",
      mappingId: getters.getLabelReleasesExportDetailsMappingId,
    };
    // Support both select release by checkbox and whole search result
    let metaData = { alvIds: getters.getLabelReleasesExportAll ? [] : getters.getSelectedLabelReleases };

    let response =  await api.triggerAction(DIR, metaData, queryParams);
    if (response.error === -1) {
      if (response.response.path !== null) {
        api.getFileFromALV(response.response.path);
        commit("setSnackbar", {
          type: "success",
          msg: i18n.t("lang_GENERAL_SNACKBAR_DOWNLOAD_SUCCESSFULL"),
        });
      }
    } else {
      let errorMsg = response.response.errorMsg;
      if (errorMsg !== undefined) {
        commit("setSnackbar", {
          type: "error",
          msg: this._vm.$alvPlugin.isLangConst(errorMsg)
            ? i18n.t(errorMsg)
            : errorMsg,
        });
      }
    }
    commit("setIsLoading", false);
  },

  // Action: Label Release Delivery
  async prepareLabelReleaseDelivery({ getters, commit, dispatch }) {
    let selectedReleases = getters.getSelectedLabelReleases;

    // selectedReleases.forEach(async releseAlvId => {
    // let details = await api.getDetailsById(DIR, releseAlvId)
    let details = await api.getDetailsById(DIR, selectedReleases);
    // let validation = await dispatch('validateReleasesDetailsForDelivery', { releaseDetails : details})

    // if(validation) {
    commit("setReleaseDeliveryDialogDetails", details);

    let queryParams = { action: "prepareReleaseForDelivery" };
    let metaData = { releaseIds: getters.getSelectedLabelReleases };

    commit("setShowReleaseDeliveryDialog", true);
    let response = await api.triggerAction(DIR, metaData, queryParams);

    if (response.error === -1) commit("setXmlFilePath", response.response.path);
    else commit("setXmlValidationErrorPath", response.response.validationFile);
    commit("setReleaseValidationInProgress", false);

    // } else {
    //     commit('setShowLabelReleaseValidationErrorDialog', true)
    // }
    // })
  },

  // Action: Export GVL TriSys Excel
  async gvlTrisysExcel({ getters, commit }) {
    let queryParams = { action: getters.getSelectedLabelReleasesAction };
    let metaData = { releaseIds: getters.getSelectedLabelReleases };

    let response = await api.triggerAction(DIR, metaData, queryParams);
    if (response.error === -1) {
      if (response.response.path !== null) {
        api.getFileFromALV(response.response.path);
        commit("setSnackbar", {
          type: "success",
          msg: i18n.t("lang_GENERAL_SNACKBAR_DOWNLOAD_SUCCESSFULL"),
        });
      }
    } else {
      commit("setShowErrorDialog", true);
      commit("setErrorDialogCsvLink", response.response.path);
      commit("setErrorMessageCode", "1LR");
    }
  },

  // Action: Export GEMA TONIS Excel
  async gemaTonisExcel({ getters, commit }) {
    let queryParams = { action: getters.getSelectedLabelReleasesAction };
    let metaData = { releaseIds: getters.getSelectedLabelReleases };

    let response = await api.triggerAction(DIR, metaData, queryParams);
    if (response.error === -1) {
      if (response.response.path !== null) {
        api.getFileFromALV(response.response.path);
        commit("setSnackbar", {
          type: "success",
          msg: i18n.t("lang_GENERAL_SNACKBAR_DOWNLOAD_SUCCESSFULL"),
        });
      }
    } else {
      commit("setShowErrorDialog", true);
      commit("setErrorDialogCsvLink", response.response.path);
      commit("setErrorMessageCode", "2LR");
    }
  },

  validateReleasesDetailsForDelivery({ commit }, details) {
    let hasPerformer = details.releaseDetails.performer !== null;
    let hasCover = details.releaseDetails.cover !== null;
    let hasDigitalReleaseDate = details.releaseDetails.dateDigital !== null;
    let hasEan = details.releaseDetails.ean !== null;
    let hasCatalogueNumber = details.releaseDetails.catalogueNumber !== null;
    let hasPLine = details.releaseDetails.pNotice !== null;
    let hasCLine = details.releaseDetails.cNotice !== null;
    let hasPriceCat = details.releaseDetails.priceCategory !== null;
    let hasLanguage = details.releaseDetails.language !== null;
    let hasGenreOne = details.releaseDetails.genre1 !== null;

    let hasAtLeastOnePlatformCheckedForDelivery = details.releaseDetails.digitalDistributionStatus.some(
      (platform) => {
        return platform.selected === "yes";
      }
    );

    // Validate Tracks
    let tracks = details.releaseDetails.tracksOnRelease;
    let hasTracks = tracks.length !== 0;
    let allTracksValidations = [];

    if (hasTracks) {
      for (let i = 0; i < tracks.length; i++) {
        let hasTrackIsrc = tracks[i].isrc !== null;
        let hasTrackArtist = tracks[i].performer !== null;
        let hasTrackAudio = tracks[i].audioTrack !== null;
        let hasTrackDuration = tracks[i].duration !== null;

        allTracksValidations.push({
          title: tracks[i].title,
          hasIsrc: hasTrackIsrc,
          hasArtist: hasTrackArtist,
          hasAudio: hasTrackAudio,
          hasDuration: hasTrackDuration,
        });
      }
    }

    // let releaseValidationErrorDetails = {
    //     'hasPerformer' :
    // }

    return false;
  },

  // async deliverLabelRelease({ getters, dispatch, commit }) {
  //     commit('setShowMainProgressbar', true)
  //     let queryParams = { "action": "deliverRelease" }
  //     let metaData = { "releaseIds" : getters.getSelectedLabelReleases }

  //     let response = await api.triggerAction(DIR, metaData, queryParams)

  //     if(response.error === -1) {
  //         let processReleaseResponse = await dispatch('processDeliverLabelRelease', { processId: response.response.processId })
  //         if(processReleaseResponse.status === 'running') {
  //             getters.getReleaseDeliveryPolling = setInterval(async () => {
  //                 await dispatch('processDeliverLabelRelease', { processId: response.response.processId }) }, 3000)
  //                 setTimeout(() => { clearInterval(getters.getReleaseDeliveryPolling) }, 1800000)
  //         }
  //     }
  // },

  // async processDeliverLabelRelease({ getters, commit }, param) {
  //     let result = await api.getProgressOfProcess(param.processId, getters.getReleaseDeliveryPolling).then(
  //         response => { return response }
  //     )
  //     commit('setMainPercentageProgressbarReleaseDelivery', result.percent)

  //     if(result.status === 'finished') {
  //         commit('setShowCloseButton', true)
  //         clearInterval(getters.getReleaseDeliveryPolling)
  //     }

  //     return result
  // }
};

export default {
  state,
  getters,
  actions,
  mutations,
};
